///<reference path="../../../node_modules/@angular/core/src/metadata/directives.d.ts"/>
import {
    Component, OnInit, AfterViewInit, Input, ViewChild, ViewContainerRef,
    ComponentFactoryResolver, ComponentFactory, Output, EventEmitter, ɵEMPTY_ARRAY
} from '@angular/core';

import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../api.service";
import {CommonService} from "../common.service";
import {currentdialogue} from "./currentdialogue";
import {solutionScript} from "./solutionScript";
import {forEach} from "@angular/router/src/utils/collection";
import {behaviorService} from "./behaviorService";
import {questionConfig} from "./question-config";
import {emailConfig} from "./email-config-component";
import {StoreService} from '../store.service';

declare var $ :any;

@Component({
    selector: 'app-case-practice-hotel',
    templateUrl: './case-practice-hotel.component.html',
    styleUrls: ['./case-practice-hotel.component.css',]
})
export class CasePracticeHotelComponent implements OnInit , AfterViewInit{
    @ViewChild("talkContainer", { read: ViewContainerRef }) talkContainer: ViewContainerRef;

    @Input() currentCase: any;
    @Input() caseType: any;
    @Input() headImageUrl: string;

    @Input() practiceMetaId: number;

    @Output() onFinish = new EventEmitter<string>();
    @Output() onExit = new EventEmitter<any>();

  	baseURL:string = "/wx";
    //baseURL:string = "http://leafprd.chinaeast2.cloudapp.chinacloudapi.cn/wx";
    //baseURL:string = "http://139.219.11.127:8091/wx";

    selecteddialogue: currentdialogue;

    solutionPart: solutionScript = new solutionScript();

    service:behaviorService = new behaviorService();


    picture: number;

    choiceBtnDisable: boolean;

    choiceClickable:boolean;

    resourceConfig:emailConfig = new emailConfig();

    started:boolean;

    sceneText:string;
    questionOptions: any;
    exitTipMessage: string;

    buttonTitle: string;
    caseFinished: boolean;


    currentQuestion: any;
    currentIndex: number;

    dynamicPoint:string;

    shadeClickable:boolean;

    scrollTop:number;

    transtionStatus:boolean;

    storybg: any;

    lock: boolean;

    delayTime: number;

    energyVal: number;

    myclass: string;

    mystatus: string;

    unreadcount: number;

    msgunreadcount: number;

    detailType: number;

    unreadsignal: string;

    emails:any;

    currentEmail:number;

    diglogueUnreadcount:number;

    diglogueList:any;

    optionSelectedIndex:number;

    ka:any;

    currentdiglogue:any;

    selectedMutliChoice:any;

    selectedPeople:number;

    dialogueStep:number;

    currentpeopleBG:string;

    emaihistlst:any;

    firstVist:boolean;

    tempHide:boolean;

    tempNextHide:boolean;

    isDisabled:boolean;

    episode:number;

    nextButtonState:boolean;

    messagebox:any;

    currentMessage:any;

    readEMailIds:any;

    readMessageIds:any;

    readDialogueIds:any;

    myhead:string;

    currentEmailType:number;

    solutionList:any;

    selectedSolution:any;

    selectedString:string;

    isShowSoultionUI:boolean;

    showChoiceDetail:boolean;

    isNeedClick:boolean;

    viewTabHistory:any;

    isFinish:boolean;

    SKIPStagedOne:boolean;

    maskType:number;

    emailShow:boolean;

    tempmindyTypeHide:boolean;
    //判断是否可以点击 dialogue
    IsEnterEmail:boolean = false;
    IsEnterMessage:boolean = false;
    isLoaded:boolean =true;

	//原始选项
	originOption:any;
	//textConfig
	configOption:any;
	//trueSelectedIndex
	trueSelectedIndex:number;

	exerciseId:number;
	learningPathId:number;
  isShowTitle: boolean = false;
  isShowTitle3: boolean = true;
  assetsRoute: string = "../../assets";

    constructor(private componentResolver: ComponentFactoryResolver,
                private route: ActivatedRoute,
                private router: Router,
                private  apiService: ApiService,
                private commonService: CommonService,
                private storeService:StoreService) {
        //this.solutionPart = new currentdialogue();
    }

    ngOnInit() {
        console.log('zxczxczxc',123)
      this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.selectedString = "选择方案";

        this.service.baseURL = this.baseURL ;

        this.route.params.subscribe(params => {
            this.service.userId = params['practiceId'];
            this.exerciseId = params['exerciseId'];
            this.learningPathId = params['learningPathId'];
        });
        const exerciseMetaId=$('#exerciseMetaId').val()
        this.apiService.learingTime({learningPathMetaId:localStorage.getItem("learningPathMetaId"),module:'情景模拟',courseUnit:'',type:1,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
            console.log(result)
          })
          console.log(exerciseMetaId)
          this.commonService.sendPostMessage(0,'isPractice' +'Complete')

        let url = this.baseURL + "/api/hasdone/"+this.service.userId;

        let that= this;
        $.ajax({
            url: url,
            type: "get",
            dataType:'json',
            headers : {
              'transtalen-token' : localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
              'transtalenuserid' : localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
            },
            success:function(data){
                //console.log(data);
                if (data!=false) {
                    that.linkToReport();
                }
            },
            error:function(er){
                console.log(er);
              if(er.status === 401 && Number(er.responseJSON.code) === 106){
                that.storeService.notification.notAuthed.next(true);
              }
            }
        });


        this.readMessageIds = [];
        this.readEMailIds = [];
        this.readDialogueIds = [];
        this.isShowSoultionUI = false;
        this.showChoiceDetail = true;
        this.isNeedClick = false;
        this.lock = false;
        this.viewTabHistory = [];
        //Mock
        this.isFinish = false;
        this.emailShow = false;
        //temp modify
        //this.solutionList = [{},{},{},{},{}];
        //this.selectedSolution = this.solutionList[0]; // {id:-1,type:1,title:"酒店淡季的客房促销方案",d:""};
        this.tempmindyTypeHide = false;

        //this.service.userId = this.userId;

        //fadeIn
        this.delayTime = 400;
        this.currentIndex = 1;//18
        this.firstVist = true;
        this.SKIPStagedOne = true;
        this.tempHide = false;
        this.tempNextHide = false;
        this.isDisabled = false;
        this.energyVal = 70;
        this.unreadcount = 0;
        this.msgunreadcount = 0;
        this.diglogueUnreadcount = 0;
        this.currentEmail = 0;
        this.optionSelectedIndex = -1;
        this.selectedPeople = 0;
        this.dialogueStep = 0;
        this.myclass = "unread";
        this.unreadsignal = "unreadsignal";
        this.mystatus = "未查看";
        this.ka = { k1:0, k2:0,k3:0,k4:0,k5:0,K6:0,k7:0};
        this.selectedMutliChoice = {};
        this.myhead ="http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLcQW7CBCWAcq9q1h3iaR5aYHWVuD14zTpJibibE81WyCujpTHlibD0HA61oojl0kCl8fChic6dQKxyICg/132";
        let url2 = this.baseURL + "/api/recovery/"+this.service.userId;
        $.ajax({
            url: url2,
            type: "get",
            dataType:'json',
            headers : {
              'transtalen-token' : localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
              'transtalenuserid' : localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
            },
            success:function(data){
                if(data.url && data.url !== ""){
                	that.myhead = data.url;
                }
                that.loadRecord(data);
            },
            error:function(er){
                console.log(er);
              if(er.status === 401 && Number(er.responseJSON.code) === 106){
                that.storeService.notification.notAuthed.next(true);
              }
            }
        });

	    this.storybg = [
	        {index:1,top:"40%",data:"你是DC Mak五星度假酒店的销售经理，<br/>管理着会务、餐饮、前厅服务等部门。<br/>"},
	        {index:2,top:"20%",data:"DC Mak是一家高端五星度假酒店<br/><br/><b>主要客戶群体：</b><br/>商务差旅、大型旅游团队<br/><br/><b>酒店价值观：</b><br/>全方位贴心服务、打造极致休闲体验<br/><br/><b>DC Mak面临的问题：</b><br/>近几年日趋激烈的行为竞争，使得酒店销量<br/>不太乐观，许多VIP客户正在逐渐流失。"},
	        {index:3,top:"10%",data:"<b>酒店现状：</b><br/>·&nbsp;&nbsp;将在两个月后淡出黄金期，转为淡季<br/>·&nbsp;&nbsp;酒店的发展趋势不容乐观，连续三年负增<br/>&nbsp;&nbsp;&nbsp;长<br/><br/><b>团队现状：</b><br/>·&nbsp;&nbsp;你和团队都面临着巨大的业绩压力<br/>·&nbsp;&nbsp;团队成员出现心态和绩效双重问题<br/><br/><b>你的压力来源于：</b><br/>·&nbsp;&nbsp;做出完美促销方案，提升淡季的销量<br/>·&nbsp;&nbsp;促进酒店中长期的良态发展，恢复销量正<br/>&nbsp;&nbsp;&nbsp;增长，弥补往年亏损<br/> ·&nbsp;&nbsp;解决团队成员的问题，保证团队工作效率<br/>&nbsp;&nbsp;&nbsp;和产出<br/><br/>请仔细阅读后续情节中提供的信息，分析并<br/>作出决策。"},
	        {index:4,top:"40%",data:"你在酒店还有五位好伙伴，一起认识一下<br/>吧！"},
	        {index:5,name:"qfbg",x:"20px",cname:"秦飞",top:"40%",data:"<span style='font-weight:bold;'>酒店总经理 - </span>在酒店18年，管理经验丰富。对于整个酒店的情况很了解，也十分清楚竞争对手的资料，是一部行走的“百科全书”。"},
	        {index:6,name:"glbg",x:"60px",cname:"高朗",top:"40%",data:"<span style='font-weight:bold;'>市场推广总监 - </span>10年工作经验，业务熟练。业余爱钻研如何订到又便宜又好的酒店。个人公众号有上万粉丝，可获得来自终端的新资讯。"},
	        {index:7,name:"jnbg",x:"110px",cname:"季宁",top:"40%",data:"<span style='font-weight:bold;'>前厅主管 - </span>85后的精致小资女，讲究生活情调，喜欢每个月出去短途游，住过不同类型的酒店，对于客户体验和创新主义有独到见解。"},
	        {index:8,name:"wlnbg",x:"160px",cname:"王立娜",top:"40%",data:"<span style='font-weight:bold;'>会务主管 - </span>擅长策划商务会议或活动，妥善完成商务团队接待任务。人缘不错，是公司中的大姐大。能很好地平衡工作和生活。"},
	        {index:9,name:"fkkbg",x:"190px",cname:"方科科",top:"40%",data:"<span style='font-weight:bold;'>工程部经理 - </span>酒店中的“万能工”，技术问题一把手。生活中是资深吃货一枚，对于城市里好吃好玩的地方都非常了解，堪称“人体GPS”。"},
	        {index:10,bg:"bg2",data:"在决策中，信息收集与分析是制胜的关键。<br/><br/>我们将赋予你<font color='#D7B118'><b>&nbsp;70&nbsp;</b></font>格精力值，它可以用来<font color='#D7B118'><b>查看各类信息</b></font>。<br/><br/>选择不同渠道的信息，精力值将会<font color='#D7B118'><b>被扣除</b></font>相应数值。<br/><br/><font color='#D7B118'><b>·&nbsp;&nbsp;友情提示&nbsp;&nbsp;·</b></font><br>一旦精力值为零，后续信息将无法读取。<br/>请合理分配精力值，有效地使用它哦~~<br/>你可以随时从进度条上观察到剩余数值。"},
	        {index:11,top:"40%",data:"早晨，你踏入酒店，与伙伴们打过招呼，走<br/>进了办公室。打开电脑，发现有新邮件和新<br/>信息等待你的处理……"},
	        {index:12,data:"请点击图标打开收件箱<br/><br/>注意: 你之后将不定期收<br/>到邮件，每查看一封邮<br/>件将会扣除1点精力值。<br/>"},
	        {index:13,data:"会议跟进-酒店淡季推广<br/>"},
	        {index:14,data:"请点击图标打开信息<br/><br/>注意: 你之后将不定期收<br/>到信息，每查看一条信<br/>息将会扣除1点精力值。<br/>"},
	        {index:15,data:"信息栏"},
	        {index:16,data:"请点击图标打开伙伴对话<br/><br/>注意: 你之后将不定期收到<br/>伙伴对话，每查看一条信<br/>息将会扣除2点精力值。<br/>"},
	        {index:17,data:"请点击头像查看TA<br/>想说的话。"},
	        {index:18,data:"信息栏"},
	        {index:19,data:"单选题"},
	        {index:20,data:"如果不想看信息，点击此处跳过"},
	        {index:21,data:"新对话"},
	        {index:22,data:"新邮件"},
	        {index:23,data:"看来你还有点犹豫不定呢，但千万记得<br/>不要陷入分析瘫痪哦！"},
	        {index:24,data:"新的资讯来啦，赶快点击查看吧。"},
	        {index:25,data:""},
	        {index:26,data:""},
	        {index:27,data:"一声召唤，伙伴就聚焦到了你的身边。"},
	        {index:28,data:""},
	        {index:29,data:""},
	        {index:30,data:"看来你对方案的撰写的确有非常高的紧迫感，那就赶紧做起来吧！",next:31},
	        {index:31,data:"在脑洞大开之后，你得到了许多灵感，现在<br/>一同来看看可行性方案吧。",next:32},
	        {index:32,data:""},
	        {index:33,data:"判断题"},
	        {index:34,data:""},
	        {index:35,data:""},
	        {index:36,data:""},
	        {index:99,data:""}
	    ]

		//this.getConfig();

        this.emails =[
            {id:90001,name:"高朗",isread:false,subject:"会议跟进-酒店淡季推广",date:"07:34 AM",desc:"基于上周的讨论，我做了一版酒店淡季推广方案的<br/>策划海报，请见附件,包括以下两点......",content:"基于上周的讨论，我做了一版酒店淡季推广方案的策划海报，请见附件，包括以下两点：<br/><br/>\n" +
                "                1.\t调整房价的公告设计图 – 指定豪华标间618元/间/晚，豪华大床房 688元/间/晚，开放昭华楼和凌绝楼的房间<br/><br/>" +
                "                2.\t推出优惠活动的小册子 – 比如说温泉、按摩、熏香、DIY亲子活动等等<br/><br/>" +
                "                另外，我建议销售部要进行交叉培训，淡季时更要保证人员都经过充分培训，才能应对未来的旺季需求，如果有任何需要市场部门支持的，我会全力配合。<br/><br/>"},
            {id:90002,name:"黎启",isread:false,subject:"辞职信",date:"07:58 AM",desc:"我仔细想了想，还是决定暂时离开工作岗位一阵子<br/>。正如您之前和我谈到的......",content:"   我仔细想了想，还是决定暂时离开工作岗位一阵子。正如您之前和我谈到的，我也觉得自己最近这段时间的工作状态非常不好。<br/><br/>" +
                "   过去的这两个月内，我的工作总是频频出错，不仅拖了整个团队的后腿，有时候还会给大家制造额外的麻烦。虽然您给了我时间去调整心态，但从现在的反馈来看，我自己也对自己的工作成绩不太满意。<br/><br/>" +
                "   所以，为了不再给团队抹黑，我正式提出辞职申请，望您能批准。也感谢这一年多来您对我的栽培。<br/><br/>"}
        ];

        this.emaihistlst =[];

        this.diglogueList =[
            {
                name:"秦飞",
                unread:1,
                icon:"qfhead",
                bg:"qfbg",
                title:"酒店总经理",
                desc:"在酒店18年，管理经验丰富，了解酒店和竞争对手情况。",
                List:[{
                    id:9510,state:0,title:"谈话主题：今天下班要不要一起去踢球？",data:["今天下班要不要一起去踢球，我找到一家很不错的足球场馆，叫上老高一起去！"]
                }],
                History:[]
            },
            {
                name:"高朗",
                unread:0,
                icon:"glhead",
                bg:"glbg",
                title:"市场推广总监",
                desc:"10年工作经验，业务熟练，个人公众号粉丝多，可获得终端资讯。",
                List:[],
                History:[]
            },
            {
                name:"季宁",
                unread:0,
                icon:"jnhead",
                bg:"jnbg",
                title:"前厅主管",
                desc:"精致小资女，住过不同类型酒店，对客户体验和创新主义有见解。",
                List:[],
                History:[]
            },
            {
                name:"王立娜",
                unread:0,
                icon:"wlnhead",
                bg:"wlnbg",
                title:"会务主管",
                desc:"擅长策划商务会议或活动，人缘不错，大姐大。",
                List:[],
                History:[]
            },
            {
                name:"方科科",
                unread:0,
                icon:"fkkhead",
                bg:"fkkbg",
                title:"工程部经理",
                desc:"技术问题一把手，资深吃货，“人肉GPS”。",
                List:[],
                History:[]
            }
        ]


        this.currentQuestion = {
            id:1,
            title:"你是否获取到了足够的信息呢？   那么，下一步，你想如何做？",
            type:"单选题",
            sub:1,
            options:[
                "“一大早上就那么多邮件和消息，脑袋都要炸了！”","“唔，每件事情感觉都挺重要的，不知道老秦怎么想，他或许能帮到我。”","“是不是找大家商量一下比较好？”"
            ]
        }



        this.selecteddialogue = new currentdialogue();

        this.messagebox = {
            List:[
                {
                    id: 1, profilePhoto: "man-photo", name: "同事", title: "酒店活动手册设计", state: 0, List: [
                        {t: 1, d: "我们酒店的活动手册设计草案的进度怎么样了？"},
                        {t: 2, d: "这个进度没问题，但是现在有个大问题！"},
                        {t: 1, d: "怎么了？"},
                        {t: 2, d: "我们和网上平台的广告位合约到期了，现在对方不肯与我们续约，这样会影响今年网约房的销量……"},
                        {t: 1, d: "怎么会这样？我们不是上个月就通知法务重新去签署合同了吗？"},
                        {t: 2, d: "法务说没有收到通知邮件。"},
                        {t: 1, d: "这件事情是谁在负责？"},
                        {t: 2, d: "呃，是黎启。"}
                    ]
                },
                {
                    id: 2, profilePhoto: "man-photo", name: "死党", title: "酒店风格调研", state: 0, List: [
                        {t: 1, d: "帮个忙，我想做个调研，你喜欢住我们酒店吗？"},
                        {t: 2, d: "额，还好吧，刚开始几次还觉得不错……"},
                        {t: 1, d: "能具体说说我们酒店有什么问题吗？"},
                        {t: 2, d: "老实说，你们酒店的硬件其实还可以，就是10年了，设施设备从没更新过。"},
                        {t: 1, d: "那除了这个之外呢？"},
                        {t: 2, d: "服务也没啥特色。"},
                        {t: 1, d: "你说的特色是像某些酒店的主题式服务吗？"},
                        {t: 2, d: "这倒不是，我是觉得不够贴心，服务不周到……"}
                    ]
                }],
            History:[
            ]
        }
        this.currentMessage = this.messagebox.List[0];
		this.questionEventEnable = {};
        //this.loadRecord(100003);
        //this.InitMockData();

        $('#step5-dialogue').on('touchmove', function (event) {
            try{
                event.stopPropagation();
                //event.preventDefault();
            }
            catch(ex){

            }
        });
    }

    initializeOptions() {
        if (!this.currentQuestion || (!this.currentQuestion.options || this.currentQuestion.options.length <= 0)) {
            this.showFinishButton();
            return;
        }

        this.questionOptions = this.currentQuestion.options.sort(function(){
            return 0.5 - Math.random();
        });
    }

    ngAfterViewInit(){
        this.commonService.initPage({
            'backgroundColor':'white'
        });
        //temp
        //var choiceBox=document.getElementById("choice");
        //var choiceBtn=document.getElementById("choiceBtn");
        //var choiceBoxHeight=choiceBox.offsetHeight;
        //var bodyHeight=document.body.offsetHeight;
        //choiceBox.style.top=bodyHeight + 'px';
        //choiceBox.style.maxHeight=document.body.offsetHeight*0.99 + 'px';
        //不需要
        //this.showTopTools();
        //debug closed by sam

        var interval = setInterval(function () {
            $("#shade").css('left', "10%").animate({
                opacity:1
            });
            clearInterval(interval);//停止
        }, 300);

    }

	getConfig(){
		let _this = this;
		this.apiService.ajax({
			url:"/assets/config.json",
			type:"get"
		}).subscribe(result => {

			if(result.sceneList){
				result.sceneList.forEach(function(item,index){
					_this.storybg[item.index-1].data = item.data;
				});
				_this.configOption = result;
			}
		});
	}

    showSceneText(){
        document.getElementById("sceneText_1").style.marginTop= 0 + 'px';
        document.getElementById("sceneText_1").style.opacity= "1";
    }

    onChoiceBtnClick(){

    }

    showFinishButton() {
        this.buttonTitle = "完成，查看报告";
        this.caseFinished = true;
        this.choiceBtnDisable = false;
    }

    close() {
        $("#shade").show();
        $("#tip1").fadeIn(500);
        this.disableRolling();
    }

    continue() {
        $("#tip1").fadeOut(500)
        $("#mask-shade").hide();
    }

    exit() {
      // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':localStorage.getItem('learningPathMetaId'),'module':'退出情景模拟1'}).then();
        this.onExit.emit(true);
    }

    scrollToBottom(disableAnimate:boolean = false) {

        if(disableAnimate){
            $("#wrap").scrollTop($("#wrap")[0].scrollHeight);
        }else{
            $('#wrap').animate({scrollTop:$("#wrap")[0].scrollHeight}, 800);
        }
    }

    test(){
        //this.initializeTalk();
    }

    onShadeClick(){
        if(this.shadeClickable){
            $("#shade").fadeOut(500);
            this.enableRolling();
            this.shadeClickable = false;
            let choiceBox = document.getElementById("choice");
            let bodyHeight = $("body").height();// document.body.offsetHeight;
            choiceBox.style.top=bodyHeight+"px";
        }
    }

    disableRolling(){
        //document.getElementById('wrap').classList.add('disableScrolling');
    }

    enableRolling(){
    }

    animate(){
        //console.log("A AAAAAA");
        $("#div-test").css('left', "30px").animate({
            opacity:1
        });
    }

    onNextStage(n){
        console.log("this.n:"+ n + "   this.lock:"+this.lock);
        //主场景内容
        if (this.lock || this.lock == undefined)
            return;
        this.lock = true;
        let that = this;

        //if
        let data = (that.storybg.length >n)? that.storybg[n-1].data : "";
        let top = (that.storybg.length >n)? that.storybg[n-1].top: 0;
        let name = (that.storybg.length >n)? that.storybg[n-1].name: "";
        let cname = (that.storybg.length >n)? that.storybg[n-1].cname: "";
        let x = (that.storybg.length >n)? that.storybg[n-1].x : 0;
        //主场景切换
        if (n==1){
            $("#shade").css("opacity","0");
            var interval = setInterval(function () {
                $("#step2-content").html(data);
                $("#shade").hide();
                $("#step2").show(that.delayTime,function () {
                    $("#step2").css('left', "5%").animate({
                        opacity:1
                    });
                    that.lock = false;
                });
                clearInterval(interval);//停止
            }, that.delayTime + 100);
        }
        else if (n>1 && n<5){
			let step2 = $("#step2");
            step2.css("opacity","0");
            var interval = setInterval(function () {
                $("#step2-content").html(data);
                step2.hide();
                step2.css("top",top);
                step2.css('left', "-450px").show("normal",function(){
                    step2.css('left', "5%").animate({
                        opacity: 1
                    },function () {
                        that.lock = false;
                    });
                });

                clearInterval(interval);//停止
            }, that.delayTime + 100);
            //第四场景后加入一场景
            if(n==4){
            	this.currentIndex = 101;
            	return false;
            }
        }
        else if (n==5){
			$("#organization").fadeOut(200);
            $("#step2").css("opacity","0");
            var interval = setInterval(function () {
                $("#step3-title").css("margin-left", x);
                $("#step3-title").html(cname);

                //$("#step3-content").css("left",+x);
                $("#step3-content").html(data);
                if (name){
                    $("#"+name).fadeIn(that.delayTime,function () {
                        $("#step3").show();
                        $("#step3").animate({
                            "opacity": 1
                        });
                        that.lock = false;
                    });
                }
                clearInterval(interval);//停止
            }, that.delayTime + 100);

        }
        //人物自述
        else if (n>5 && n<=9 ){
            let left = 10+(n-5)*3+"%";
            //$("#step3").css("transform", "scale(0)");
            //对话内容
            //$("#step3").hide(this.delayTime,function () {
            $("#step3").css("left",left);
            $("#step3-title").css("margin-left", x);
            $("#step3-title").html(cname);
            //$("#step3-content").html("");
            $("#step3-content").html(data);
            //$("#step3-content").css("opacity", 0.2);
            //$("#step3").transition({ scale: 0.2 }, 500, 'linear');
            $("#step3").css("transform", "scale(0.1)");
            $("#step3").show();
            //$("#step3").css("transform", "scale(1)");
            if (name){
                $("#"+name).fadeIn(that.delayTime,function () {
                    $("#step3").animate({
                        "opacity": 1
                    });
                });
            }
            var interval = setInterval(function () {
                $("#step3").css("transform", "scale(1)");
                //$("#step3-content").css("opacity", 1);
                clearInterval(interval);//停止
                that.lock = false;
            }, that.delayTime);

        }//精力的介绍
        else if (n==10 ){
            let bg = that.storybg[n-1].bg;
            that.lock = true;
            //$("#nin").html(data);
            $("#step3").css("transform", "scale(0.1)").hide(that.delayTime,function () {
                $("#qfbg").hide();
                $("#glbg").hide();
                $("#jnbg").hide();
                $("#wlnbg").hide();
                $("#fkkbg").hide();
                $("#wrap").hide().addClass(bg).fadeIn();
                $("#step4-shade").show();
                $("#nin").html(data);
                $("#emgvalue").show();
                $("#emgmaxvalue").show();
                $("#emgtitle").show();
                $("#emgnumber").show();
                //that.lock = true;
            });
        }
        else if (n==11 ){
            that.lock = true;
            $("#step4-shade").hide();
            $("#step2").show();
            $("#step2").css("left","-450px").animate({
                "opacity":0.2
            },function () {
                //console.log("1.----------------------");
                $("#emailicon").css("position","absolute").css("z-index","0").css("top","48%").css("left","35%").show();
                $("#step2").css("top",top);
                var interval = setInterval(function () {
                    $("#step2-content").html(data);
                    $("#step2").css('left', "5%").animate({
                        opacity: 0.9
                    });
                    that.lock = false;
                    clearInterval(interval);//停止
                }, that.delayTime+100);

            });
            //that.lock = false;

        }
        else if (n==12){
            that.lock = true;
            $("#nin2").html(data);
            $("#know").hide();
            $("#nin").hide();
            $("#step2").css("opacity","0");
            $("#step2").hide(200,function () {});
            var interval = setInterval(function () {
                $("#emailicon").css("position","fixed").css("z-index","1000002").animate({
                    "top": "5.5rem",
                    "left": "2.8rem",
                    "opacity":0
                },200,function () {
                    $("#emailicon").css("top", "0.5rem").css("left", "4.4rem").animate({"opacity":"1"},500,function () {
                        $("#emailunreader").show();
                        $("#step4-shade").show();
                        $("#nin2").show();
                        $("#emghelparrow").hide();
                        $("#emailhelparrow").show();
                        $("#emgvalue").css("position","absolute").css("z-index","0");
                        $("#emgmaxvalue").css("position","absolute").css("z-index","-1");
                        $("#emgtitle").css("position","absolute").css("z-index","0");
                        $("#emgnumber").css("position","absolute").css("z-index","0");
                        that.unreadcount = 2;
                    });
                });
                clearInterval(interval);//停止
            }, that.delayTime+200);
        }
        //邮件试用
        else if (n==13 ){
            //$("#emailicon").unbind();
			$("#emailicon").css("z-index","1000002")
            $("#step5-email").show();


            //$("#emgmaxvalue").hide();
            $("#step4-shade").hide();

            $("#emailhelparrow").hide();
            $("#nin2").hide();
            //$("#step5-mail").show();

        }
        //信息帮助蒙版
        else if (n==14) {

            $("#nin2").html(data);
            $("#step5-email").hide();
            $("#step4-shade").show();


            $("#emailhelparrow").css("left","5.1rem").show();
            $("#nin2").css("left","3.5rem").show();
            $("#emailicon").css("position","absolute").css("z-index","0");
            $("#emailunreader").css("position","absolute").css("z-index","0");
            $("#messageicon").show();
            $("#messageunreader").show();
            this.msgunreadcount  = this.getUnreadMessage();
            //this.msgunreadcount = 2;
        }
        else if (n==15) {

            $("#step4-shade").hide();
            $("#emailhelparrow").hide();
            $("#nin2").hide();
            $("#step5-message").show();
        }
        //对话帮助蒙版
        else if (n==16) {
            this.diglogueUnreadcount = 1;
            $("#nin2").html(data);
            $("#step5-message").hide();
            $("#step4-shade").show();
            $("#dialogueicon").show();
            $("#dialogueunreader").show();

            $("#messageicon").css("position","absolute").css("z-index","0");
            $("#messageunreader").css("position","absolute").css("z-index","0");
            $("#emailhelparrow").css("left","6.2rem").show();
            $("#nin2").css("left","3.5rem").show();

            $("#emghelparrow").hide();
            $("#know").hide();
            $("#nin").hide();
            this.lock = false;

        }
        //帮助用户选择秦飞
        else if (n==17){
            //$("#step4-shade").show();
            //this.maskType = 5;
            $("#step4-shade").hide();
            $("#step94-shade").show();
            $("#dialoghelparrow").css({
                "left":"0.6rem",
                "top":"4.4rem"
            }).show();
            //dialoghelparrow
            $("#nin3").html(data);
            $("#nin3").css({"top":"5.9rem","left":"0.5rem"});

            $("#step5-dialogue").show();
            $("#diaploghelphead").show();
            $("#diaploghelpunreader").show();
        }
        else if (n==18){
            //对话介绍场景
            console.log(this.selecteddialogue);
            if (this.selecteddialogue.IsLast()){
                this.diglogueUnreadcount = this.selecteddialogue.UnreadCount(this.diglogueList);
                $("#step3").hide();
                $("#"+this.currentpeopleBG).hide();
                console.log("step5-dialogue-list show 1");
                $("#step5-dialogue-list").show();
                return;
            }

            let text =  this.selecteddialogue.content.data[this.selecteddialogue.index];
            let people = this.diglogueList[this.selecteddialogue.people].name;
            this.selecteddialogue.Next();

            $("#step3").css("transform", "scale(0)");

            //对话内容
            $("#step3").css({"left":"10%", "width":"80%"});
            $("#step3-title").css("margin-left", "30px");
            $("#step3-title").html(people);
            $("#step3-content").css({"padding-top": "25px", "padding-bottom": "20px"});
            $("#step3-content").html(text);
            $("#step3").css("transform", "scale(0)");
            $("#step3").show();


            var interval = setInterval(function () {
                $("#step3").css("transform", "scale(1)");
                that.lock = false;
                clearInterval(interval);//停止
            }, that.delayTime);

            return;
        }
        else if (n == 19){
            return;
            //单选题
            //this.gotoChoice();
        }
        else if (n == 20){
            //选择B
            $("#single-choice").fadeOut();
            this.emailShow = true;
            this.showSkipTip();
        }
        else if (n == 21){
            this.currentIndex = 18;
            $("#step5-dialogue").show();
            $("#downIcon").hide();
            $("#skiptip").hide();
            return;
        }
        else if (n == 22){
            this.onEmailTouch();
            $("#downIcon").hide();
            $("#skiptip").hide();
            return;
        }
        else if ( n==23 || n==24){
			this.showfakeIcon();
            var interval = setInterval(function () {
            	$("#step2").stop().css("opacity","0");
                $("#step2-content").html(data);
                $("#step2").hide();
                $("#step2").css("top",top);
                $("#step2").css('left', "-450px").show("normal",function(){
                    $("#step2").css('left', "5%").animate({
                        opacity: 1
                    });
                });
                that.lock = false;
                clearInterval(interval);//停止
            }, that.delayTime + 100);

        }
        else if (n==25)
        {
            //选B项继续收集信息
            var interval = setInterval(function () {
            	$("#step2").stop().css("opacity","0");
                $("#step2-content").html(data);
                $("#step2").hide();
                $("#step2").css('left', "-450px").show("normal",function(){
                    $("#step2").hide();
                   	that.hidefakeIcon();
                   	that.showSkipTip();
                });

                //that.lock = false;
                clearInterval(interval);//停止
            }, that.delayTime + 100);

            //添加邮件与短信
            if (this.solutionPart.episode == 0)
                this.AddChoiceHotelScript2();
            else if (this.solutionPart.episode == 1){
                this.AddChoiceUpgradeScript2();
            }
            else if (this.solutionPart.episode == 2){
                this.AddChoiceEmployeeScript2();
            }
            return;
        }
        else if (n== 26){
            //Message Infomation
            $("#step5-message").show();
            that.lock = false;
        }
        else if (n== 27){
            this.showfakeIcon();
            var interval = setInterval(function () {
            	$("#step2").stop().css("opacity","0");
                $("#step2-content").html(data);
                $("#step2").hide();
                $("#step2").css("top",top);
                $("#step2").css('left', "-450px").show("normal",function(){
                    $("#step2").css('left', "5%").animate({
                        opacity: 1
                    },function () {
                        that.lock = false;
                    });
                });

                clearInterval(interval);//停止
            }, that.delayTime + 100);

        }
        else if (n==28)
        {
        	this.hidefakeIcon();
            //选C项继续收集信息
            var interval = setInterval(function () {
                $("#step2-content").html(data);
                $("#step2").stop().css("opacity","0");
                $("#step2").hide();
                $("#step2").css('left', "-450px").show("normal",function(){
                    $("#step2").hide();
                    that.showSkipTip();
                });

                clearInterval(interval);//停止
            }, that.delayTime + 100);


            //添加邮件与短信
            if (this.solutionPart.episode == 0){
                this.AddChoiceHotelDialogueScript();
            }
            else if (this.solutionPart.episode == 1){
                this.AddChoiceUpgradeDialogueScript();
            }
            else if (this.solutionPart.episode == 2){
                this.AddChoiceEmployeeDialogueScript();
            }

        }
        else if (n== 29){
            //Message Infomation
            $("#step5-dialogue").show();
            that.lock = false;
        }
        else if (n== 31){
            $("#wrap").hide().addClass("bg4").show();
            //console.log("方案选择。。。。");
            $("#step2").show();
			this.showfakeIcon();

            $("#step2").css("left","-450px").animate({
                "opacity":0.2
            },function () {
                $("#step2").css("top",top);
                var interval = setInterval(function () {
                    $("#step2-content").html(data);
                    $("#step2").css('left', "5%").animate({
                        opacity: 0.9
                    });
                    //if (that.storybg[n-1].next)
                    //    that.currentIndex = that.storybg[n-1].next;
                    //选择题
                    that.currentIndex = 40;
                    that.lock = false;

                    clearInterval(interval);//停止
                }, that.delayTime+100);
            });
            return;
        }
        else if (n == 32){
            //酒店方案导师提示
            let text = "很棒，你心中已有了选择。<br/><br/>" +
                "接下来，请评估你的可行性方案中哪个才是最佳方案，递交给董事会吧。<br/><br/>";
            if (this.solutionPart.episode == 2)
                text =    "很棒，你心中已有了选择。<br/><br/>接下来，请评估你的可行性方案中哪个才是最佳方案，递交给总经理吧。<br/><br/>";
            //this.isDisabled = true;
            this.showfakeIcon();
            this.goToTutorReview(text);
            //this.onGotoDialogue("")
            that.lock = false;
            this.loadRecordDialogs(function(){});
        }
        else if (n == 33){
            this.HideTutorReview();

            //方案是非题
            //if (this.solutionPart.episode == 0)
            $("#single-choice").removeClass("single-choice-small");
            //this.choice
            this.QuestionHotelSolutionTrueOrFalse();

            var interval = setInterval(function () {
                that.showQuestionDialogue(1);
                //that.isDisabled = false;
                that.hidefakeIcon();
                clearInterval(interval);//停止
            }, 200);
        }
        else if (n == 34){
            $("#single-choice").hide();
            //方案是单选题
            //if (this.solutionPart.episode == 0)
            this.QuestionHotelSolutionSingleChoice();


            var interval = setInterval(function () {
                that.showQuestionDialogue(1);
                clearInterval(interval);//停止
            }, 100);
        }
        else if (n == 35){
            //
            $("#single-choice").hide();
            //if (this.solutionPart.episode == 0){
            //this.QuestionHotelSolutionSingleChoice();
            let tip = this.GetHotelSolutionTip();
            this.isDisabled = true;
            this.goToTutorReview(tip);
            this.showfakeIcon();
            //this.onGotoDialogue("")
            //that.lock = false;

            //}
            that.lock = false;
        }
        else if (n == 36){

            if (this.optionSelectedIndex >-1){
                this.HideTutorReview();
                setTimeout(function(){
                	that.GotoLastQuestion();
                },100)

                $("#single-choice").css("top","3.2rem");
                $("#single-choice").removeClass("single-choice-small");
                this.hidefakeIcon();
                //that.lock = true;
                //console.log("222 this.lock="+this.lock);
            }
            return;
        }
        else if (n == 39) {
            this.lock = false;
        }
        else if (n == 40){
            this.diglogueUnreadcount = 0;
            this.showfakeIcon();
            //$("#nin2").html("如果拿不准方案的话，您的<br/>伙伴们随时乐意效劳哦！");

            setTimeout(function(){
            	$("#step2").stop().css("opacity","0");
                $("#step93-shade").show();
                that.AddHotelSolution();
                that.selectedSolution = that.solutionList[0];
                $("#step6-solution-tab").show();
                $("#step6-solution-content").show();
                $("#step6-solution-button").show();
            }, that.delayTime + 100);

            return;
        }

        else if (n == 60){
            this.goToTutorReview("<br/>在向大老板汇报之前，你想就方案中的一些项目和相关伙伴再次商议，快决定一下，要和谁来沟通吧！<br/><br/><br/>");
            this.showfakeIcon();
            that.lock = false;
        }
        else if (n == 61){
            this.HideTutorReview();
            $("#single-choice").css("top","1.6rem");
            this.gotoExceptChoice(this.currentQuestion.id);
            this.hidefakeIcon();
        }
        else if (n == 62){
            this.gotoExceptChoice(this.currentQuestion.id);
        }
        else if (n == 99){
            this.gotoCreateReport();
        }
        else if(n == 101){
        	//组织机构页面
        	let step2 = $("#step2");
            step2.css("opacity","0");
            $("#organization").css({"opacity":"1","transform":"translateX(0)"});
        	this.currentIndex = 5;
        	this.lock = false;
        	return false;
        }
        this.currentIndex++;
    }

    onUnlock(){
        this.lock = false;
        console.log("this.currentIndex = " + this.currentIndex);
        this.onNextStage(this.currentIndex);
    }

    onViewContent(){
        let that = this;
        this.continue();

        if (this.detailType == 1){
            //console.log(this.currentEmail);
            //console.log(this.emails);
            let email =  this.currentEmailType == 1 ? this.emails[this.currentEmail] : this.emaihistlst[this.currentEmail];

            if (email.isread)
                return;

            this.showfakeIcon();
            $("#subtractOne").css("top","2.4rem").css("left","1.8rem").css("opacity","1");
            $("#subtractOne").show().animate({
                "top": "0",
                "left": "1.8rem",
                "opacity":"0.1"
            },1000,function () {
                $("#subtractOne").hide(1000);
                $("#emgnumber").html(that.energyVal+" / 70");
            });

            this.energyVal--;

            $("#emgvalue").css("width",parseInt(160 / 70 * this.energyVal+ "") +"px");

            $("#send_email").html(email.name);
            $("#send_subject").html(email.subject);
            $("#send_date").html(email.date);
            $("#email-detail").html(email.content);
            if (email.id == 10031){
               $("#receiver").html("所有人");
            }else{
               $("#receiver").html("我");
            }

            email.isread = true;
            this.unreadcount--;

            if (email.id){
                this.readEMailIds.push(email.id);
                this.ka.k2++;
            }

            $("#step5-email").hide();
            $("#step5-email-content").show();

            this.service.RecordNodeInfo(this,0,this.detailType,email.id,this.currentQuestion.id);
        }
        else if (this.detailType == 2){

            if (this.currentMessage.state == 1)
                return;

            this.showfakeIcon();
            $("#subtractOne").css("top","2.4rem").css("left","1.8rem").css("opacity","1");
            $("#subtractOne").show().animate({
                "top": "0",
                "left": "1.8rem",
                "opacity":"0.1"
            },1000,function () {
                $("#subtractOne").hide(1000);
                $("#emgnumber").html(that.energyVal+" / 70");

            });

            this.energyVal--;

            $("#emgvalue").css("width",parseInt(160 / 70 * this.energyVal+ "") +"px");

            this.currentMessage.state = 1;
            this.msgunreadcount = this.getUnreadMessage();
            this.readMessageIds.push(this.currentMessage.id);

            if (this.currentMessage.id)
                this.ka.k2++;

            $("#step5-message").hide();
            $("#step5-message-content").show();
            this.isShowTitle = true;

            this.service.RecordNodeInfo(this,0,this.detailType,this.currentMessage.id,this.currentQuestion.id);

        }
        else if (this.detailType == 3){

            //防止重复点击
            if (this.selecteddialogue.content.state == 1)
                return;

            $("#subtractTwo").css("top","2.4rem").css("left","1.8rem").css("opacity","1");
            $("#subtractTwo").show().animate({
                "top": "0",
                "left": "1.8rem",
                "opacity":"0.1"
            },1000,function () {
                $("#subtractTwo").hide(1000);
                $("#emgnumber").html(that.energyVal+" / 70");
            });
            this.diglogueList[this.selectedPeople].unread--;

            this.selecteddialogue.content.state = 1;
            //this.diglogueList[this.selectedPeople].List[this.selecteddialogue.section ].state = 1;
            this.energyVal-=2;

            this.unreadsignal = "none";
            //this.diglogueUnreadcount--;
            this.diglogueUnreadcount = this.getDialogUnreadCount();
            this.currentIndex = 18;

            $("#emgvalue").css("width",parseInt(160 / 70 * this.energyVal+ "") +"px");
            $("#step5-dialogue-list").hide();
            this.onGotoDialogue(0);
            this.service.RecordNodeInfo(this,0,this.detailType,this.selecteddialogue.id,this.currentQuestion.id);
        }

    }

    onReturnEmail(){
        this.currentEmail = 0;
        $("#step5-email-content").hide();
        $("#step5-email").show();
    }

    onReadEmail(n,type){
        //console.log("Email ABCDEF...");
        this.detailType = 1;
        this.currentEmail = n;
        this.currentEmailType = type;

        let email =  this.currentEmailType == 1 ? this.emails[this.currentEmail] : this.emaihistlst[this.currentEmail];

        if (email.isread){
            $("#send_email").html(email.name);
            $("#send_subject").html(email.subject);
            $("#send_date").html(email.date);
            $("#email-detail").html(email.content);
            $("#step5-email").hide();
            $("#step5-email-content").show();
            if (email.id == 10031){
               $("#receiver").html("所有人");
            }else{
               $("#receiver").html("我");
            }
        }
        else{
        	if(this.energyVal < 1){
        		$("#tipMessage").show();
        	}else{
        		this.exitTipMessage = "选择看这封邮件需要扣除 <span style='color: #1a6ef4;font-weight:bolder;'>1</span> 点精力值,是否查看？";
	            $("#tip_message").html(this.exitTipMessage);
	            $("#mask-shade").show();
	            $("#tip1").fadeIn();
        	}
        }

    }

    onReadMessage(msgInfo){
        //消息
        this.detailType = 2;
        this.currentMessage = msgInfo;

        //this.showfakeIcon();
        //console.log("Message ABCDEF...");
        if (msgInfo.state == 0){
        	if(this.energyVal < 1){
        		$("#tipMessage").show();
        	}else{
	            this.exitTipMessage = "选择看这条信息需要扣除 <span style='color: #1a6ef4;font-weight:bolder;'>1</span> 点精力值,是否查看？";
	            $("#tip_message").html(this.exitTipMessage);
	            $("#mask-shade").show();
	            $("#tip1").fadeIn();
           }
        }
        else{
            $("#step5-message").hide();
            $("#step5-message-content").show();
          this.isShowTitle = true;
        }

    }

    onReturnMessage(){

        $(".message-content-body").scrollTop(0);//恢复的开头
        $("#step5-message-content").hide();
      this.isShowTitle = false;
        $("#step5-message").show();

    }

    onEmailTouch(){
      $("#emailicon").removeClass("shake");
        console.log(this.currentIndex);

        if(this.currentIndex <= 12){
        	return false;
        }

        if (this.isFinish)
            return;
		this.lockIconEvent();

        if ($("#single-choice").css('display')!='none'){
            this.tempHide = true;
            $("#single-choice").hide();
        }

        if (this.currentIndex<13)
            return;
        else if (this.currentIndex == 13){
            this.onUnlock();
        }
        else{
            //显示邮件
            this.showPopup("step5-email");
            this.HideNextButton();
        }
    }
    onEmailClose(){
    	this.UnLockIconEvent();
		this.IsEnterEmail = true;
        //console.log("tempmindyTypeHide="+this.tempmindyTypeHide+"  tempHide="+this.tempHide + " currentIndex="+this.currentIndex);
        let bgg = $("#wrap").hasClass("bg4");
        //console.log("bg4="+bgg);
        if (this.tempmindyTypeHide){
            this.tempmindyTypeHide = false;
            $("#mindyicon").show();
            $("#choiceTip").show();
        }
        //临时跳出
        if (this.tempHide){
            this.tempHide = false;
            $("#step5-email").hide();
            $("#single-choice").show();
            return;
        }

        if (bgg){
            this.HideNextButton();
        }

        //解决方案跳出
        if (this.ShowSolutionUI())
            return;

        if (this.currentIndex == 14) {
            this.onUnlock();
        }
        else{
            $("#step5-email").hide();
            if(!bgg){
            	this.ShowNextButton();
            }
            if (this.currentIndex == 22){
                //跳转到单选题
                this.gotoMultiChoice();
            }
        }
    }
    onMessageTouch(){
      $("#messageicon").removeClass("shake");
		//必须先进入邮件
		if(!this.IsEnterEmail){
			return false;
		}


        console.log("CurrentIndex="+this.currentIndex);
        if (this.isFinish)
            return;
		this.lockIconEvent();

        if ($("#single-choice").css('display')!='none'){
            this.tempHide = true;
            $("#single-choice").hide();
        }

        if (this.currentIndex == 15){
            this.onUnlock();
        }
        else{
            this.showPopup("step5-message");
            this.HideNextButton();
        }

    }
    onDialogueList(n){

        this.selectedPeople = n;
        this.showfakeIcon();
        $("#diaploghelphead").hide();
        $("#diaploghelpunreader").hide();
        $("#step94-shade").hide();

        if (this.maskType == 5){
            this.maskType = -1;
            $("#step5-dialogue").show();
            $("#step5-dialogue-list").hide();
        }
        else{
            $("#step5-dialogue").hide();
            $("#step5-dialogue-list").show();
        }
    }
    onDialogueTouch(n,type){
        this.detailType = 3;

        let list = (type == 1 ? this.diglogueList[this.selectedPeople].History[n] : this.diglogueList[this.selectedPeople].List[n]);
        //console.log(list.state);
        //直接进入对话
        if (list.state == 1){
            $("#step5-dialogue-list").hide();
            this.selecteddialogue.index = 0;
            this.selecteddialogue.people = this.selectedPeople;
            this.selecteddialogue.content = list;
            this.selecteddialogue.section = n;
            this.selecteddialogue.length = list.data.length;
            this.selecteddialogue.GoFirst();
            this.onGotoDialogue(0);
            //console.log("ABCD......");
            return;
        }else if(list.state == 2){
        	return;
        }

		if(this.energyVal < 1){
        	$("#tipMessage").show();
        }else{
	        this.exitTipMessage = "本次对话需要扣除 <span style='color: #1a6ef4;font-weight:bolder;'>2</span> 点精力值,<br/>是否查看？";
	        $("#tip_message").html(this.exitTipMessage);
	        $("#mask-shade").show();
	        $("#tip1").fadeIn();
	        //第一段对话

	        //let list = (type == 1 ? this.diglogueList[this.selectedPeople].History[n] : this.diglogueList[this.selectedPeople].List[n]);
	        this.selecteddialogue.id = list.id;
	        this.selecteddialogue.index = 0;
	        this.selecteddialogue.people = this.selectedPeople;
	        this.selecteddialogue.content = list;
	        this.selecteddialogue.section = n;
	        this.selecteddialogue.length = list.data.length;
        }

    }
    onGotoDialogue(n){

        this.currentIndex = 18;
        let css = {
            left: "30%",
            width:"158px",
            height:"496px",
            position:"absolute"
        }
        if (this.selectedPeople == 0){
            css = {
                left: "30%",
                width: "167px",
                height: "510px",
                position:"absolute"
            }
        }
        if (this.selectedPeople == 1){
            css = {
                left: "30%",
                width: "159px",
                height: "517px",
                position:"absolute"
            }
        }
        else if (this.selectedPeople == 2){
            $("#"+this.diglogueList[this.selectedPeople].bg).css("top", "20%");
            css = { left: "30%", width: "123px", height: "500px", position:"absolute"}
        }
        else if (this.selectedPeople == 3){
            $("#"+this.diglogueList[this.selectedPeople].bg).css("top", "20%");
            css ={
                left: "30%",
                width: "169px",
                height: "480px",
                position: "absolute"
            }
        }

        if (this.currentpeopleBG)
            $("#"+this.currentpeopleBG).hide();


        $("#"+this.diglogueList[this.selectedPeople].bg).css(css);
        $("#wrap").css({padding:"0px"});
        $("#"+this.diglogueList[this.selectedPeople].bg).fadeIn();
        this.currentpeopleBG = this.diglogueList[this.selectedPeople].bg;
        //解锁
        //this.lock = false;
        this.onUnlock();
    }
    onReturnIntroduce(){
        //this.hidefakeIcon();
        $("#step5-dialogue").show();
        $("#step5-dialogue-list").hide();

    }
    onDiglogueTouch(){
      $("#dialogueicon").removeClass("shake");
    	//必须先进入消息
		if(!this.IsEnterMessage){
			return false;
		}
        //this.emailShow = true;

        //console.log("onDiglogueTouch:"+this.currentIndex);
        //if (this.isDisabled)
        //    return;

        //this.isDisabled = true;
        //console.log("2 isDisabled:"+this.isDisabled);

        if (this.isFinish)
            return;

		this.lockIconEvent();
        if ($("#single-choice").css('display')!='none'){
            this.tempHide = true;
            $("#single-choice").hide();
        }

        if ($("#mindyicon").css('display')!='none'){
            this.tempmindyTypeHide = true;
            $("#mindyicon").hide();
            $("#choiceTip").hide();
        }

        if (this.currentIndex == 17){
            this.onUnlock();
        }
        else{
            this.showPopup("step5-dialogue");
            this.HideSolutionUI();
            this.HideNextButton();
        }
    }

    goToTutorReview(dialogue){
        //this.isDisabled = true;
        console.log("isDisabled:"+this.isDisabled);
        $("#tutorview-tipText").html(dialogue);

        //.css("dispaly","none");
        $("#tutorview").fadeIn(500);
        $("#tutorviewTip").show();
        $("#tutorviewTip").css("transform", "scale(0.3)");
        $("#tutorview-tipText").css("opacity","0.1");
        $(".tutorview-arrow").hide();

        // $("#tutorviewTip").css("opacity:", "0.1");
        var interval = setInterval(function () {
            //let h = $("#tutorviewTip").height();
            //$("#tutorviewTip").css("top","calc(75% - "+(h+50)+"px)");

            $("#tutorviewTip").css("transform", "scale(1)");
            $("#tutorview-tipText").css("opacity","1");
            $("#tutorview-arrow").css("dispaly","inline-block");
            $("#tutorview-arrow").show();
            $(".tutorview-arrow").show();

            clearInterval(interval);//停止
        }, this.delayTime);
        //console.log("2 height:"+h);
        //$("#wrap").hide().addClass("bg4").show();
    }
    HideTutorReview(){

        $("#tutorviewTip").css("transform", "scale(0.3)");
        $("#tutorview-tipText").css("opacity","0.1");
        $("#tutorview").css("opacity","0.3").hide().css("opacity","1");
        $(".tutorview-arrow").css("opacity","0.3").hide().css("opacity","1");

        var interval = setInterval(function () {
            //.animate("display","none");
            //$("#tutorview").hide();
            $("#tutorviewTip").hide();
            //$("#tutorview-arrow").css("dispaly","inline-block");
            $("#tutorview-arrow").hide();
            //$(".tutorview-arrow").hide();
            clearInterval(interval);//停止
        }, this.delayTime);
        //console.log("2 height:"+h);
        //$("#wrap").hide().addClass("bg4").show();
    }


    dialogueclosed(){
    	this.UnLockIconEvent();
        console.log("currentIndex Id ="+this.currentIndex);
        $("#step5-dialogue").hide();
        console.log("this.tempmindyTypeHide="+this.tempmindyTypeHide);
        if (this.tempmindyTypeHide){
            this.tempmindyTypeHide = false;
            $("#mindyicon").show();
            $("#choiceTip").show();
        }
        //临时跳出
        if (this.tempHide){
            this.tempHide = false;

            $("#single-choice").show();
            return;
        }

        //解决方案跳出
        if (this.ShowSolutionUI())
            return;

        //第一次访问
        if (this.firstVist){
            this.firstVist = false;
            console.log("Question Id 22222="+this.currentQuestion.id);
            //$("#single-choice").css("top","2.6rem");
            this.showQuestionDialogue(1);
            //$("#single-choice").show();
        }
        else{
            //下一步
            if ($("#single-choice").css('display')=='none' || this.tempNextHide){
                this.tempNextHide = false;
                $("#downIcon").show();
                $("#skiptip").show();
            }
        }
    }

    gotoMultiChoice(){
        //按题型跳转
        let type = 2;
        this.lock = true;
        //跳转至选择题
        //跳转至题目
        $("#single-choice").hide();
        if (this.currentQuestion && this.currentQuestion.id == 1){
            this.selectedMutliChoice = {};
            //this.selectedMutliChoice
            this.currentQuestion = {
                id:2,
                title:"还记得高效决策的第一步应该做哪些步骤呢？<br/>千万别忘记界定问题时，期待结果和衡量标准也是相当关键的要素哦！<br/>那么，从你阅读到的那么多信息中，选择出你期望达到的结果是什么吧？",
                type:"多选题",
                sub:2,
                options:[
                    "所有跨部门的伙伴都能接受的促销方案，并严格执行销售计划",
                    "保证两个月后的酒店淡季销量同比去年增长50%",
                    "让消费者对我们淡季的活动满意，促成更多“回头客”",
                    "采用不同的激励手段提升员工士气，保持高涨的工作情绪",
                    "以公司的价值观为基础，升级客户体验流程",
                    "协助员工更好地正视自己的状态，不要通过离职来解决问题",
                    "以特色服务打造酒店的招牌形象，形成口碑效应",
                    "将酒店今年的销量翻一番，并在未来保持长期的稳健增长",
                    "能够帮助员工找到最适合他/她的工作岗位"
                ]
            }

            //for var s in this.selectedMutliChoice
            //this.selectedMutliChoice = {};

            $(".choice-title").html(this.currentQuestion.title);

        }
        else if (this.currentQuestion && this.currentQuestion.id == 4){
            //$(".choice-title").hide();
            //$("#mindyTip").show();
            //console.log("AAAAAA BBBB CCCCC");
        }else if (this.currentQuestion && this.currentQuestion.id == 5) {
            //this.sel
            this.optionSelectedIndex = -1;
            this.currentQuestion = {
                id:6,
                title:"看过邮件之后，下一步，你想怎么做呢？",
                type:"单选题",
                sub:1,
                options:[
                    "【满意】大家真给力，提供了好多有用信息，现在我能动笔写方案了。",
                    "唔，这信息似乎不够啊，要不再去问问情况？",
                    "信息倒是有了，但还想听听其他意见，不知道大家有啥想法？"
                ]
            }
            //type = 1;
            $("#mindyicon").show();
            $("#tipText").html(this.currentQuestion.title);
            $("#choiceTip").show();
            $(".choice-title").html("");
            $("#single-choice").addClass("single-choice-small");
            this.moveToHistory(0);
            this.moveToHistory(1);
            this.moveToHistory(2);
            this.moveToHistory(3);
            this.moveToHistory(4);
        }
        else if (this.currentQuestion && this.currentQuestion.id == 6){
            this.optionSelectedIndex = -1;
            this.selectedMutliChoice = {};

            if (this.solutionPart.episode == 0)
                this.currentQuestion = {
                    id:7,
                    title:"现在你已收集到了很多信息，让我们来看看，其中哪些才是你真正需要的？",
                    type:"判断题",
                    sub:3,
                    options:[
                        "VVIP客户团下下周二来酒店举办商务会议及活动",
                        "客户满意度下滑，比上个月又低了5%",
                        "网约房的合同需要重新洽谈，下周要出席会议",
                        "设备老旧的问题客户已经提到了好多次",
                        "酒店行业抱团取暖是常态",
                        "同类型的酒店房价比我们低，可降低房价进行促销",
                        "员工要休产假，黎启状态又不好，团队人手短缺",
                        "可与旅行社和用车平台结成战略性伙伴关系",
                        "套餐活动和积分兑奖可能是这次促销上的重点推荐",
                        "会务营销或成为这次淡季里的卖点之一",
                        "注重促销活动的沟通方案，信息传递要及时",
                        "员工的年轻化是客户满意度下降的关键",
                        "调动酒店的成员参与促销，激励措施要合理",
                        "软装方面的供应商，发现有一家价廉物美"
                    ]
                }
            else if (this.solutionPart.episode == 1)
                this.currentQuestion = {
                    id:17,
                    title:"现在你已收集到了很多信息，让我们来看看，其中哪些才是你真正需要的？",
                    type:"判断题",
                    sub:3,
                    options:[
                        "VVIP客户团下下周二来酒店举办商务会议及活动",
                        "客户满意度下滑，比上个月又低了5%",
                        "网约房的合同需要重新洽谈，下周要出席会议",
                        "设备老旧的问题客户已经提到了好多次",
                        "大数据时代更要为消费者提供时尚、贴心、健康、快乐、舒适的酒店住宿服务",
                        "建立所有入住顾客的资料库，提供个性化服务",
                        "员工要休产假，黎启状态又不好，团队人手短缺",
                        "提升酒店服务人员的个人形象和服务素质",
                        "加强酒店的安全管理，提升服务人员的安全意识，部署技术手段保障客户人身安全",
                        "年轻人更喜欢健身、社交的空间，要重视这方面需求",
                        "客户是上帝，所以他们的任何要求都需要被立即满足",
                        "酒店餐饮的口味不太好，应该多创新菜品，增加口味",
                        "需要考虑酒店数字化、智能化的服务体验的实施可能性",
                        "机器人应该马上进入酒店，用来提高人员的工作效率"
                    ]
                }
            else if (this.solutionPart.episode == 2)
                this.currentQuestion = {
                    id:27,
                    title:"现在你已收集到了很多信息，让我们来看看，其中哪些才是你真正需要的？",
                    type:"判断题",
                    sub:3,
                    options:[
                        "VVIP客户团下下周二来酒店举办商务会议及活动",
                        "客户满意度下滑，比上个月又低了5%",
                        "员工觉得自己的性格并不适合团队的工作风格",
                        "跨部门同事建议好好考察问题员工，别太优柔寡断",
                        "下属马上要休产假，会务团队的压力持续增加",
                        "网约房的合同需要重新洽谈，下周要出席会议",
                        "VVIP客户团的接待对酒店来说很重要",
                        "请辞下属的主管反映他工作情况尚可，平时比较努力",
                        "采取加薪的方式是留住员工的激励手段之一",
                        "设备老旧的问题客户已经提到了好多次",
                        "员工的问题要尽快解决，不影响团队士气"
                    ]
                }
            $(".choice-title").html(this.currentQuestion.title);
        }
        $("#step5-dialogue").hide();
        $("#downIcon").hide();
        $("#skiptip").hide();

        //this.showQuestionDialogue(2);

        let That = this;
        var interval = setInterval(function () {
            That.showQuestionDialogue(1);
            clearInterval(interval);//停止
        }, 200);

        //$("#single-choice").show();

    }
	LogErrorInfo(er){
		//防止对象为 null
		var errorInfo = {};
		if(er){
			errorInfo = er;
		}
		var _this = this;
		var messageINfo = {
			currentIndex :_this.currentIndex,
			emails : _this.emails,
			emaihistlst :_this.emaihistlst,
			messagebox: _this.messagebox,
			energyVal : _this.energyVal,
			stage : _this.solutionPart.episode,
			currentQuestion : _this.currentQuestion,
			questionEventEnable : _this.questionEventEnable,
			readCopySate:$("#diaploghelpunreader").css("display"),
			errorInfo : JSON.stringify(errorInfo)
		};
		var postData = {
			errorMsg:JSON.stringify(messageINfo)
		}
    let that= this;
		$.ajax({
		    url: "http://139.219.11.127:8080/ddi/exposeoutapi/inserterrormsg",
		    type: "POST",
		    contentType:'application/json;charset=utf-8',
		    data: JSON.stringify(postData) ,
		    dataType: "JSON",
        headers : {
          'transtalen-token' : localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
          'transtalenuserid' : localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
        },
		    success: function (data) {
          if(data.success){
            alert("错误信息已经发送,不要重复提交");
          }
		    },
        error: function (er) {
          if(er.status === 401 && Number(er.responseJSON.code) === 106){
            that.storeService.notification.notAuthed.next(true);
          }
        }
		});
	}
	showSkipTip(){
		let downIconCover = $("#downIconCover");
		downIconCover.show();
		setTimeout(function(){
			$("#downIcon").fadeIn();
            $("#skiptip").show();
            downIconCover.hide();
		},2000);
	}
    showPopup(name){
        //关闭所有弹层显示邮件
        if($("#step5-message").css("display")=="block"){
            $("#step5-message-content").hide();
          this.isShowTitle = false;
            $("#step5-message").hide();
        }
        if($("#step5-email").css("display")=="block"){
            $("#step5-email-content").hide();
            $("#step5-email").hide();
        }
        if($("#step5-dialogue").css("display")=="block"){
            $("#step5-dialogue").hide();
            $("#step5-dialogue-list").hide();
        }

        if($("#"+name).css("display")=="none"){
            $("#"+name).show();
        }
        else
        {
            //$("#step5-email").hide();
        }
    }
    //选择某一题
    onOptionClick($event,i){
        $event.stopPropagation();
        if (this.currentQuestion.sub == 1 || this.currentQuestion.sub == 5)
            this.optionSelectedIndex = i;
        else if (this.currentQuestion.sub == 2){
            this.selectedMutliChoice[i] = !this.selectedMutliChoice[i];
        }
        /*
        //多选题控制修改
        var chkEnabled = false;
        if(this.currentQuestion.sub == 2 || this.currentQuestion.sub == 3){
        	 $.each(this.selectedMutliChoice, function(i,item) {
	        	if(item){
	        		chkEnabled = item;
	        	}
	        });
	        this.optionSelectedIndex = chkEnabled ? 1:-1;
        }
        */

    }
    //btnSaveEnable:boolean = true;
    questionEventEnable:any = {};
    //选择题
    onQuestionBtnClick($event){
    	let That = this;
    	let qstId = this.currentQuestion.id;
		if(That.questionEventEnable[qstId] && That.questionEventEnable[qstId] == 1){
			return false;
		}else{
			That.questionEventEnable[qstId] = 1;
			//释放锁定
			setTimeout(function(){
				That.questionEventEnable[qstId] = 0;
			},500);
		}

        $event.stopPropagation();

        //多选必须选中
        let chkEnabled = false;

        $.each(this.selectedMutliChoice, function(i,item) {
        	if(item){
        		chkEnabled = item;
        	}
        });
        //排序题设置为选中
        if(this.currentQuestion.sub == 4){
        	chkEnabled = true;
        }

        //console.log("this.currentQuestion.id = "+this.currentQuestion.id +"       this.optionSelectedIndex = "+this.optionSelectedIndex);
        if ((this.currentQuestion.sub == 1 || this.currentQuestion.sub == 5) && this.optionSelectedIndex == -1){
        	return false;
        }
        else if ((this.currentQuestion.sub > 1 && this.currentQuestion.sub < 5) && (this.selectedMutliChoice == null || !chkEnabled )){
        	return false;
        }
        this.GetSingleTureAnswer();

        if (this.currentQuestion.id == 3)
            this.solutionPart.episode = this.trueSelectedIndex;

        if (this.currentQuestion.id == 8){
            this.service.SaveSortQuestionAndAnswer(this,this.currentQuestion.id,
                this.currentQuestion.sub, [
                    "客户满意度下滑，比上个月又低了5%",
                    "同类型的酒店房价比我们低，可降低房价进行促销",
                    "注重促销活动的沟通方案，信息传递要及时",
                    "可与旅行社和用车平台结成战略性伙伴关系",
                    "套餐活动和积分兑奖可能是这次促销上的重点推荐",
                    "会务营销或成为这次淡季里的卖点之一",
                    "调动酒店的成员参与促销，激励措施要合理"
                ], this.currentQuestion.options, this.solutionPart.episode);
        }else if (this.currentQuestion.id == 18){

            this.service.SaveSortQuestionAndAnswer(this,this.currentQuestion.id,
                this.currentQuestion.sub, [
                    "客户满意度下滑，比上个月又低了5%",
                    "大数据时代要为消费者提供时尚、贴心、健康、快乐、舒适的酒店住宿服务",
                    "建立所有入住顾客的资料库，提供个性化服务",
                    "提升酒店服务人员的个人形象和服务素质",
                    "加强酒店的安全，提升服务人员的意识，部署技术手段保障客户人身安全",
                    "年轻人更喜欢健身、社交的空间，要重视这方面需求",
                    "需要考虑酒店数字化、智能化的服务体验的实施可能性"
                ], this.currentQuestion.options, this.solutionPart.episode);
        }else if (this.currentQuestion.id == 28){

            this.service.SaveSortQuestionAndAnswer(this,this.currentQuestion.id,
                this.currentQuestion.sub, [
                    "员工觉得自己的性格并不适合团队的工作风格",
                    "跨部门同事建议好好考察问题员工，别太优柔寡断",
                    "下属马上要休产假，会务团队的压力持续增加",
                    "VVIP客户团的接待对酒店来说很重要",
                    "请辞下属的主管反映他工作情况尚可，平时比较努力",
                    "采取加薪的方式是留住员工的激励手段之一",
                    "员工的问题要尽快解决，不影响团队士气"
                ], this.currentQuestion.options, this.solutionPart.episode);
        }else if (this.currentQuestion.id >=30 && this.currentQuestion.id <=32){
            this.service.SaveSolutionQuestion(this,
                this.currentQuestion.id,
                this.currentQuestion.sub,
                this.solutionList,
                this.solutionPart.episode
            );
        }
        else{
            //保存选项
            this.service.SaveQuestionAndAnswer(this,
                this.currentQuestion.id,
                this.currentQuestion.sub,
                this.trueSelectedIndex,
                this.GetMutliTureAnswer(),
                this.solutionPart.episode);
        }

        //第一选项
        if (this.currentQuestion.id == 1){
            if (this.trueSelectedIndex == 0)
            {
                this.gotoMultiChoice();
            }//B选项
            else if (this.trueSelectedIndex == 1){
                //新对话
                this.diglogueList[0].unread += 1;
                this.diglogueList[0].List.push({
                    id:99100,title:"我的想法吗？从个人角度我可以给你一点建议。",state:0,data:[
                        "你问我的意见吗？我个人建议你好好想想什么事情是最能够帮助我们酒店提升业绩的，我希望既有短期的快速增长，又不要成为昙花一现。",
                        "另外，我听说你的团队里面现在有些状况，要妥善解决，千万不要在关键时刻掉链子啊。"
                    ]
                });
                this.diglogueList[0].List.reverse();
                this.dialogueStep = 1;
                this.currentIndex = 20;
                this.onUnlock();

                //增加1段对话
                this.dialogueAnimations(this.getDialogUnreadCount());

            }//C选项
            else if (this.trueSelectedIndex == 2){
                this.ka.k7+=1;
                //新对话
                this.diglogueList[0].unread = 1;

                if (this.diglogueList[0].List[0].state == 0){
                    this.diglogueList[0].List = [];
                }

                this.diglogueList[0].List.push(this.resourceConfig.emailList["99110"]);

                this.diglogueList[0].List.reverse();

                this.diglogueList[1].unread = 1;
                this.diglogueList[1].List.push(this.resourceConfig.emailList["99111"]);


                this.diglogueList[2].unread = 1;
                this.diglogueList[2].List.push(this.resourceConfig.emailList["99112"]);


                this.diglogueList[3].unread = 1;
                this.diglogueList[3].List.push(this.resourceConfig.emailList["99113"]);
                this.diglogueList[4].unread = 1;
                this.diglogueList[4].List.push(this.resourceConfig.emailList["99114"]);
                this.dialogueStep = 1;
                //console.log("this.diglogueUnreadcount="+this.diglogueUnreadcount);
                //增加5段对话
                this.dialogueAnimations(this.getDialogUnreadCount());
                $("#step5-dialogue-list").hide();
                this.currentIndex = 20;
                this.onUnlock();
            }
            //保存用户答题记录

        }//第二道多选题
        else if (this.currentQuestion.id == 2) {
            $("#single-choice").hide();
            this.selectedMutliChoice ={};
            this.currentQuestion = {
                id:3,
                title:"根据你期望的结果和标准，界定现在最需要处理的问题是？",
                type:"单选题",
                sub:1,
                options:[
                    "应对酒店淡季，设计有特色的促销方案，提升销量",
                    "提升酒店的客户体验流程，增加客户转化率及粘性",
                    "怎样处理员工的问题，保证在接待VVIP客户团时人手不短缺，服务质量不下降"
                ]
            };
            this.optionSelectedIndex = -1;

            $(".choice-title").html(this.currentQuestion.title);
            //this.showQuestionDialogue(1);
            let That = this;
            var interval = setInterval(function () {
                That.showQuestionDialogue(1);
                clearInterval(interval);//停止
            }, 200);
        }//第三道题
        else if (this.currentQuestion.id == 3){


            $("#single-choice").hide();
            this.selectedMutliChoice ={};
            this.currentQuestion = {
                id:4,
                title:"基于所期望的结果，你觉得衡量标准是什么？",
                type:"多选题",
                sub:2,
                options:[
                    "控制成本，不要有太多花销",
                    "达到今年自己和整个团队的KPI指标",
                    "客户满意度在下个月上升至95%",
                    "团队士气保持高位，激励措施到位",
                    "在一个月内看到员工行动上的改变，保证个人绩效达标",
                    "市场的反馈良好",
                    "各部门配合与响应速度超过行业平均标准",
                    "保证自己团队的稳定性，使提供的服务和销售质量不受到影响",
                    "处理员工问题要保证公平公正，兼顾对团队其他成员的影响",
                    "团队及跨部门伙伴对方案的接受度高",
                    "方案的执行较为容易，实施计划不复杂"
                ]
            };
			//this.optionSelectedIndex = -1;
            $(".choice-title").html(this.currentQuestion.title);
            let That = this;
            var interval = setInterval(function () {
                That.showQuestionDialogue(1);
                clearInterval(interval);//停止
            }, 300);
            //this.showQuestionDialogue(1);

        }
        else if (this.currentQuestion.id == 4){
        	var _this = this;
            this.loadRecordDialogs(function(){
	            //导师问题1
	            _this.optionSelectedIndex = -1;
	            _this.currentQuestion = {
	                id:5,
	                title:"恭喜你，顺利地找到自己要处理的问题。接下来，需要思考的是如何找到解决问题所需的信息。试试看，你会怎么做呢？",
	                type:"单选题",
	                sub:1,
	                options:[
	                    "唔，要是信息能再多一点就好了，要不我再问问别人？",
	                    "天呐，时间来不及了，还是赶紧先把可行性方案做出来吧。"
	                ]
	            }

	            $("#wrap").hide().addClass("bg3").fadeIn();
	            $("#mindyicon").show();
	            $("#tipText").html(_this.currentQuestion.title);
	            $("#choiceTip").show();
	            $(".choice-title").html("");
	            $("#single-choice").hide();
	            $("#single-choice").addClass("single-choice-small");
	            $("#single-choice").show();
            });

        }
        else if (this.currentQuestion.id == 5){
            //选择答案 剧情3分支
            //跳转下一题
            $("#single-choice").removeClass().addClass("fontSize16");
            $("#mindyicon").hide();
            $("#choiceTip").hide();

            $("#step5-dialogue-list").hide();
            //邮件
            $("#emailicon").show();
            $("#emailunreader").show();
            //短信
            $("#messageicon").show();
            $("#messageunreader").show();

            //隐藏单选框
            $("#single-choice").hide();

            //console.log("this.optionSelectedIndex="+this.optionSelectedIndex);

            //选择B得1分
            if (this.trueSelectedIndex == 1){
                //选B跳转到选方案
                this.currentIndex= 31;
                this.onUnlock();
                return;
            }

            //剧情下跳
            this.showSkipTip();

            if (this.solutionPart.episode == 0){
                this.AddChoiceHotelScript1();
            }
            else if (this.solutionPart.episode == 1){
                this.AddChoiceUpgradeScript1();
            }
            else if (this.solutionPart.episode == 2){
                this.AddChoiceEmployeeScript1();
            }


        }else if (this.currentQuestion.id == 6){
            let tip = "";

            //console.log("第6题 this.solutionPart.episode="+this.solutionPart.episode);
            $("#single-choice").removeClass().addClass("fontSize16");
            $("#mindyicon").hide();
            $("#choiceTip").hide();
            $("#single-choice").hide();
            if (this.trueSelectedIndex == 0) {
                //tip = "看来你对方案的撰写的确有非常高的紧迫感，那就赶紧做起来吧！";
                //Goto 可行性方案
                this.currentIndex = 31;
                this.onUnlock();
            }
            else if (this.trueSelectedIndex == 1) {
                //tip = "看来你还有点犹豫不定呢，但千万记得不要陷入分析瘫痪哦！";
                //Goto 邮件+信息补充
                this.currentIndex = 23;
                this.onUnlock();
            }
            else if (this.trueSelectedIndex == 2){
                this.currentIndex = 27;
                this.onUnlock();
                //tip = "看来你还有点犹豫不定呢，但千万记得不要陷入分析瘫痪哦！";
            }

        }else if (this.currentQuestion.id == 7){
        	$("#single-choice").hide();
			this.optionSelectedIndex = 1;
            this.currentQuestion = {
                id:8,
                title:"苦思冥想过后，你已经挑选好了需要的信息，请为它们排个序吧。",
                type:"排序题",
                sub:4,
                options:[
                    "客户满意度下滑，比上个月又低了5%",
                    "同类型的酒店房价比我们低，可降低房价进行促销",
                    "注重促销活动的沟通方案，信息传递要及时",
                    "可与旅行社和用车平台结成战略性伙伴关系",
                    "套餐活动和积分兑奖可能是这次促销上的重点推荐",
                    "会务营销或成为这次淡季里的卖点之一",
                    "调动酒店的成员参与促销，激励措施要合理"
                ]
            }
            //排序值随机打乱
            this.currentQuestion.options.sort(function() {
			     return (0.5-Math.random());
			})
            $(".choice-title").html(this.currentQuestion.title);
             setTimeout(function(){
            	That.showQuestionDialogue(1);
            },200);
        }else if (this.currentQuestion.id == 8){
            let that = this;
            //跳入选择方案场景1

			this.loadRecordDialogs(function(){
				//导师问题2
	            that.optionSelectedIndex = -1;

	            if (that.solutionPart.episode == 0 || that.solutionPart.episode == 1){
	                that.currentQuestion = {
	                    id:9,
	                    title:"时间就在你收集与分析信息的时候悄悄溜走了，现在到了要制定方案的时候，看看你会怎么做吧。",
	                    type:"单选题",
	                    sub:1,
	                    options:[
	                        "【咬笔杆】我果然是天才，现在已经有了好多想法，赶快写下来先！",
                            "哎，立娜、高朗，你们有空吗？我正好想和你们一起聊聊酒店促销的事儿。",
	                        "【自信】方案在手，天下我有，促销方案我基本有眉目了！"
	                    ]
	                }
	            }
	            else{
	                that.currentQuestion = {
	                    id:29,
	                    title:"时间就在你收集与分析信息的时候悄悄溜走了，现在到了要制定方案的时候，看看你会怎么做吧。",
	                    type:"单选题",
	                    sub:1,
	                    options:[
	                        "哎，立娜、小季，你们有空吗？我正好想和你们一起聊聊黎启的事儿。",
	                        "唔，好记性不如烂笔头，把手里的信息整整，弄几个方案出来先！",
	                        "方案在手，天下我有，黎启的事儿我已经想到办法了！"
	                    ]
	                }
	            }

	            $("#wrap").hide().addClass("bg3").fadeIn();
	            $("#mindyicon").show();
	            $("#tipText").html(that.currentQuestion.title);
	            $("#choiceTip").show();
	            $(".choice-title").html("");
	            $("#single-choice").hide();
	            $("#single-choice").addClass("single-choice-small");
	            $("#single-choice").show();
			});

        }
        else if (this.currentQuestion.id == 9 ){
            console.log("this.optionSelectedIndex= "+this.optionSelectedIndex);

            $("#mindyicon").hide();
            $("#choiceTip").hide();
            $("#single-choice").hide();

            if (this.trueSelectedIndex == 0 || this.trueSelectedIndex == 1)
            {
                //计算
                if (this.trueSelectedIndex == 1)
                    this.ka.k7+=3;

                this.currentIndex = 31;
                this.onUnlock();
                return;
            }
            else{
                //console.log("第四部分场景！");
                $("#wrap").hide().addClass("bg4").show();
                //this.unreadcount = 0;

                this.currentIndex = 32;
                this.onUnlock();
                return;
            }

        }else if (this.currentQuestion.id == 17){
        	$("#single-choice").hide();
			this.optionSelectedIndex = 1;
            this.currentQuestion = {
                id:18,
                title:"苦思冥想过后，你已经挑选好了需要的信息，请为它们排个序吧。",
                type:"排序题",
                sub:4,
                options:[
                    "客户满意度下滑，比上个月又低了5%",
                    "大数据时代要为消费者提供时尚、贴心、健康、快乐、舒适的酒店住宿服务",
                    "建立所有入住顾客的资料库，提供个性化服务",
                    "提升酒店服务人员的个人形象和服务素质",
                    "加强酒店的安全，提升服务人员的意识，部署技术手段保障客户人身安全",
                    "年轻人更喜欢健身、社交的空间，要重视这方面需求",
                    "需要考虑酒店数字化、智能化的服务体验的实施可能性"
                ]
            }
            //排序值随机打乱
            this.currentQuestion.options.sort(function() {
			     return (0.5-Math.random());
			})
            $(".choice-title").html(this.currentQuestion.title);
            setTimeout(function(){
            	That.showQuestionDialogue(1);
            },200);
        }else if (this.currentQuestion.id == 18){
            //跳入选择方案场景1
			var that = this;
			this.loadRecordDialogs(function(){
				//导师问题2
	            that.optionSelectedIndex = -1;
	            that.currentQuestion = {
	                id:9,
	                title:"时间就在你收集与分析信息的时候悄悄溜走了，现在到了要制定方案的时候，看看你会怎么做吧。",
	                type:"单选题",
	                sub:1,
	                options:[
	                    "【咬笔杆】我果然是天才，现在已经有了好多想法，赶快写下来先！",
	                    "哎，立娜、高朗，你们有空吗？我正好想和你们一起聊聊酒店服务升级的事儿。",
	                    "【自信】方案在手，天下我有，促销方案我基本有眉目了！"
	                ]
	            }

	            $("#wrap").hide().addClass("bg3").fadeIn();
	            $("#mindyicon").show();
	            $("#tipText").html(that.currentQuestion.title);
	            $("#choiceTip").show();
	            $(".choice-title").html("");
	            $("#single-choice").hide();
	            $("#single-choice").addClass("single-choice-small");
	            $("#single-choice").show();
			});

        }
        else if (this.currentQuestion.id == 27){
			$("#single-choice").hide();
			this.optionSelectedIndex = 1;
            this.currentQuestion = {
                id:28,
                title:"苦思冥想过后，你已经挑选好了需要的信息，请为它们排个序吧。",
                type:"排序题",
                sub:4,
                options:[
                    "员工觉得自己的性格并不适合团队的工作风格",
                    "跨部门同事建议好好考察问题员工，别太优柔寡断",
                    "下属马上要休产假，会务团队的压力持续增加",
                    "VVIP客户团的接待对酒店来说很重要",
                    "请辞下属的主管反映他工作情况尚可，平时比较努力",
                    "采取加薪的方式是留住员工的激励手段之一",
                    "员工的问题要尽快解决，不影响团队士气"
                ]
            }
            //排序值随机打乱
            this.currentQuestion.options.sort(function() {
			     return (0.5-Math.random());
			})
            $(".choice-title").html(this.currentQuestion.title);
             setTimeout(function(){
            	That.showQuestionDialogue(1);
            },200);
        }
        else if (this.currentQuestion.id == 28){
            //跳入选择方案场景1
			var that = this;
			this.loadRecordDialogs(function(){
				//导师问题2
	            that.optionSelectedIndex = -1;

	            that.currentQuestion = {
	                id:29,
	                title:"时间就在你收集与分析信息的时候悄悄溜走了，现在到了要制定方案的时候，看看你会怎么做吧。",
	                type:"单选题",
	                sub:1,
	                options:[
	                    "哎，立娜、小季，你们有空吗？我正好想和你们一起聊聊黎启的事儿。",
	                    "唔，好记性不如烂笔头，把手里的信息整整，弄几个方案出来先！。",
	                    "方案在手，天下我有，黎启的事儿我已经想到办法了！"
	                ]
	            }

	            $("#wrap").hide().addClass("bg3").fadeIn();
	            $("#mindyicon").show();
	            $("#tipText").html(that.currentQuestion.title);
	            $("#choiceTip").show();
	            $(".choice-title").html("");
	            $("#single-choice").hide();
	            $("#single-choice").addClass("single-choice-small");
	            $("#single-choice").show();
			});

        }
        else if (this.currentQuestion.id == 29){

            $("#mindyicon").hide();
            $("#choiceTip").hide();
            $("#single-choice").hide();

            if (this.trueSelectedIndex == 0 || this.trueSelectedIndex == 1)
            {
                //计算
                if (this.trueSelectedIndex == 1)
                    this.ka.k7+=3;

                this.currentIndex = 31;
                this.onUnlock();
                return;
            }
            else{
                //console.log("第四部分场景！");
                $("#wrap").hide().addClass("bg4").show();
                //this.unreadcount = 0;

                this.currentIndex = 32;
                this.onUnlock();
                return;
            }
        }
        //酒店解决方案选择
        else if (this.currentQuestion.id >= 30 && this.currentQuestion.id <=32 ){
        	let that = this;
			this.loadRecordDialogs(function(){
				if (!that.isNeedClick)
	                return;

	            $("#step6-solution-tab").hide();
	            $("#step6-solution-content").hide();
	            $("#step6-solution-button").hide();
	            that.currentIndex = 32;
	            that.onUnlock();
			});
        }

        else if (this.currentQuestion.id >= 33  && this.currentQuestion.id <=35){
            this.currentIndex = 34;
            this.onUnlock();
        }
        else if(this.currentQuestion.id >= 36  && this.currentQuestion.id <=38){

            if (this.optionSelectedIndex>-1){
                //单选题
                this.currentIndex = 35;
                this.onUnlock();
            }

        }
        else if (this.currentQuestion.id >=39 && this.currentQuestion.id <=41){
            //console.log("this.lock = true?" + (this.lock == true));
            this.lock = true;
            $("#mindyicon").fadeOut();
            //$("#tipText").html(this.currentQuestion.title);
            $("#choiceTip").fadeOut();
            //$(".choice-title").html("");
            $("#single-choice").hide();

            if (this.trueSelectedIndex == 0)
                this.currentIndex = 99;
            else if (this.trueSelectedIndex == 1 || this.trueSelectedIndex == 2 || this.trueSelectedIndex == 3){
                this.currentQuestion.id = 0;
                this.currentIndex  = 60;
            }
            this.onUnlock();
        }
        else if (this.currentQuestion.id == 60){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();

        }else if (this.currentQuestion.id == 61){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }else if (this.currentQuestion.id == 62){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }else if (this.currentQuestion.id == 63){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }else if (this.currentQuestion.id == 64){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }else if (this.currentQuestion.id == 65){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }
        else if (this.currentQuestion.id == 66){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }
        else if (this.currentQuestion.id == 67){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            this.gotoCreateReport();
        }
        else if (this.currentQuestion.id == 70){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }
        else if (this.currentQuestion.id == 71){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }
        else if (this.currentQuestion.id == 72){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }
        else if (this.currentQuestion.id == 73){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }
        else if (this.currentQuestion.id == 74){
            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }
        else if (this.currentQuestion.id == 75){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }
        else if (this.currentQuestion.id == 76){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            this.gotoCreateReport();
        }
        else if (this.currentQuestion.id == 80){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }
        else if (this.currentQuestion.id == 81){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }
        else if (this.currentQuestion.id == 82){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }
        else if (this.currentQuestion.id == 83){

            if (this.selectedMutliChoice === {})
                return;

            $("#single-choice").hide();
            //todo....

            this.selectedMutliChoice ={};
            this.optionSelectedIndex = -1;
            this.currentIndex  = 62;
            this.onUnlock();
        }
        else if (this.currentQuestion.id == 84){

            if (this.trueSelectedIndex == -1)
                return;

            $("#single-choice").hide();
            this.gotoCreateReport();
        }

    }

    reportFlag:boolean = false;
    gotoFinish($event){
		let That = this;
		if(That.reportFlag){
			return false;
		}
		That.reportFlag = true;

        let url = this.baseURL + "/api/finsh";
        url += "/" + this.service.userId;
        let that = this;
        $.ajax({
            url: url,
            data:{},
            type: "POST",
            dataType:'json',
            headers : {
              'transtalen-token' : localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
              'transtalenuserid' : localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
            },
            success:function(data){
                That.apiService.getNewReportKas(That.service.userId).subscribe((result)=>{
                    if(result){
                      That.apiService.getLevelInfo(result.reports[0]);
                      That.linkToReport();
                      That.reportFlag = false;
                    }
                })
            },
            error:function(er){
                if(er.status === 401 && Number(er.responseJSON.code) === 106){
                  that.storeService.notification.notAuthed.next(true);
                }else{
                  That.linkToReport();
                }
                That.reportFlag = false;
            }
        });
    }

    onTrueFalseClick(n){
        if (!this.selectedMutliChoice[n])
            this.selectedMutliChoice[n] = true;
        else
            this.selectedMutliChoice[n] = !this.selectedMutliChoice[n];

         //多选题控制修改
        var chkEnabled = false;
        if(this.currentQuestion.sub == 2 || this.currentQuestion.sub == 3){
        	 $.each(this.selectedMutliChoice, function(i,item) {
	        	if(item){
	        		chkEnabled = item;
	        	}
	        });
	        this.optionSelectedIndex = chkEnabled ? 1:-1;
        }
    }

    onDownClick(n){

        let temp =this.currentQuestion.options[n];
        this.currentQuestion.options[n] = this.currentQuestion.options[n+1];
        this.currentQuestion.options[n+1] = temp;

    }

    onUpClick(n){
        let temp =this.currentQuestion.options[n];
        this.currentQuestion.options[n] = this.currentQuestion.options[n-1];
        this.currentQuestion.options[n-1] = temp;
    }

    onMessageClose(){
    	this.UnLockIconEvent();

        let bgg = $("#wrap").hasClass("bg4");

    	this.IsEnterMessage = true;
        if (this.tempmindyTypeHide){
            this.tempmindyTypeHide = false;
            $("#mindyicon").show();
            $("#choiceTip").show();
        }
        //临时跳出
        if (this.tempHide){
            this.tempHide = false;
            $("#step5-message").hide();
            $("#single-choice").show();
            return;
        }
        if (bgg){
            this.HideNextButton();
        }
        //解决方案跳出
        if (this.ShowSolutionUI())
            return;

        $("#step5-message").hide();
        if(!bgg){
        	this.ShowNextButton();
        }
        if (this.SKIPStagedOne)
        {
            this.currentIndex = 16;
            this.onUnlock();
        }
    }

    lockIconEvent(){
    	this.showfakeIcon();
    }
    UnLockIconEvent(){
    	this.hidefakeIcon();
    }

    onCloseHelp(n){
        this.SKIPStagedOne = false;
        this.onDialogueList(n);
    }

    moveToHistory(n){
        let data= null;
        let len = this.diglogueList[n].List.length;
        for (var i= len-1; i>=0 ;i--){
            if (this.diglogueList[n].List[i].state == 1)
                this.diglogueList[n].History.unshift(this.diglogueList[n].List[i]);
            else{
                this.diglogueList[n].List[i].state = 2;
                this.diglogueList[n].History.unshift(this.diglogueList[n].List[i]);
            }

        }

    }
/*
    moveToHistory(n){
        let data= null;
        let len = this.diglogueList[n].List.length;
        for (var i= len-1; i>=0 ;i--){
            if (this.diglogueList[n].List[i].state == 1)
                this.diglogueList[n].History.unshift(this.diglogueList[n].List[i]);
            else{
                this.diglogueList[n].List[i].state = 2;
                this.diglogueList[n].History.unshift(this.diglogueList[n].List[i]);
            }

        }

    }
 */

    getDialogUnreadCount(){

        let myListCnt = this.diglogueList.length;
        let unread = 0;
        let len = 0;

        for (var j= 0; j<myListCnt;j++){

            len = this.diglogueList[j].List.length;
            for (var i= len-1; i>=0 ;i--){
                if (this.diglogueList[j].List[i].state == 0)
                    unread++;
            }

//          len = this.diglogueList[j].History.length;
//          for (var k= len-1; k>=0 ;k--){
//              if (this.diglogueList[j].History[k].state == 0)
//                  unread++;
//          }

        }

        return unread;
    }


    addNewEmail(newemails){
    	var _this = this;
        //let history = this.emaihistlst;
        //this.emaihistlst = this.emails;
        let len = newemails.length;
        //filter newemails
//      var tempEmails = [];
//      newemails.forEach(function(item,index){
//      	let flag = true;
//      	_this.emails.forEach(function(item2,index){
//      		if(item.id == item2.id){
//      			flag = false;
//      		}
//      	});
//      	_this.emaihistlst.forEach(function(item2,index){
//      		if(item.id == item2.id){
//      			flag = false;
//      		}
//      	});
//      	if(flag){
//      		tempEmails.push(item);
//      	}
//
//      });



        for (var i= len-1; i>=0 ;i--)
            this.emails.unshift(newemails[i]);
        //this.emails = newemails;
    }

    getUnreadEmail(){
        let len = this.emails.length;
        let count = 0;
        for (var i= len-1; i>=0 ;i--)
            if (this.emails[i].isread == false)
                count++;

        len = this.emaihistlst.length;
        for (var i= len-1; i>=0 ;i--)
            if (this.emaihistlst[i].isread == false)
                count++;

        return count;
    }

    getUnreadMessage(){
        let len = this.messagebox.List.length;
        let count = 0;
        for (var i= len-1; i>=0 ;i--)
            if (this.messagebox.List[i].state == 0)
                count++;

        len = this.messagebox.History.length;
        for (var i= len-1; i>=0 ;i--)
            if (this.messagebox.History[i].state == 0)
                count++;
        console.log("未读短信："+count);
        return count;
    }

    addNewMessage(newmsgs){
    	var _this = this;
    	var tempMsgs = [];
    	/*
        newmsgs.forEach(function(item,index){
        	let flag = true;
        	_this.messagebox.List.forEach(function(item2,index){
        		if(item.id == item2.id){
        			flag = false;
        		}
        	});
        	_this.messagebox.History.forEach(function(item2,index){
        		if(item.id == item2.id){
        			flag = false;
        		}
        	});
        	if(flag){
        		tempMsgs.push(item);
        	}

        });
        */
        let len = newmsgs.length;

        for (var i= len-1; i>=0 ;i--)
            this.messagebox.List.unshift(newmsgs[i]);

        //this.messagebox.List = tempMsgs;
    }

    showTopTools(){
        $("#emgtitle").show();
        $("#emgnumber").show();
        $("#emgvalue").show();
        $("#emgmaxvalue").show();
        $("#dialogueicon").show();
        $("#dialogueunreader").show();
        $("#emailicon").show();
        $("#emailunreader").show();
        $("#messageicon").show();
        $("#messageunreader").show();
        $("#wrap").hide().addClass("bg2").fadeIn();
    }

    //获取答题信息
    getSelectItem(n){
        if (this.currentQuestion.sub == 1 || this.currentQuestion.sub == 5)
            return this.optionSelectedIndex == n;
        //console.log("option Index["+n+"] = "+this.optionSelectedIndex);
        return this.selectedMutliChoice[n] == true;
    }

    isSelected(){
        let bool = false;
        //console.log("sub:"+this.currentQuestion.sub);
        if (this.currentQuestion.sub == 1 || this.currentQuestion.sub == 5)
            return this.optionSelectedIndex>-1;
        else if (this.currentQuestion.sub == 2){
            for(var  item in this.selectedMutliChoice) {
                //console.log("A:"+this.selectedMutliChoice[item]);
                //this.selectedMutliChoice.forEach(function(item,index){
                if (this.selectedMutliChoice[item])
                    return true;
                //});
            }
        }

        return bool;

    }

    getPaddingTop(){
        return (this.currentQuestion.options.length>7) ? 'padding-top: 0.1rem;':'padding-top: 0.7rem;'
    }

    showQuestionDialogue(type){

        let timeout = 100;
        let that = this;
//      if (that.currentQuestion.sub == 4)
//			timeout = 300;
        this.showChoiceDetail = false;
		var singleChoice = $("#single-choice");

    	singleChoice.show();
    	singleChoice.css("opacity","0.2");
    	singleChoice.css("transform", "rotate(90deg)");

        setTimeout(function(){
            singleChoice.css('transform', "rotate(0deg)").animate({
                opacity: 1
            },function () {
                that.showChoiceDetail = true;
            });
        },timeout);

    }

    HideNextButton(){

        if ($("#downIcon").css('display')!='none'){
            this.nextButtonState = true;
            $("#downIcon").hide();
            $("#skiptip").hide();
            //$("#single-choice").hide();
        }
    }
    ShowNextButton(){
        if (this.nextButtonState){
            this.nextButtonState = false;
            $("#downIcon").show();
            $("#skiptip").show();
            //$("#single-choice").hide();
        }
    }

    HideSolutionUI(){

        if ($("#step6-solution-tab").css('display')!='none'){
            this.isShowSoultionUI = true;
            $("#step6-solution-tab").hide();
            $("#step6-solution-content").hide();
            $("#step6-solution-button").hide();
            //$("#single-choice").hide();
        }
    }
    ShowSolutionUI(){
        if (this.isShowSoultionUI){
            this.isShowSoultionUI = false;
			this.nextButtonState = false;
			setTimeout(function(){
				$("#step6-solution-tab").show();
            	$("#step6-solution-content").show();
            	$("#step6-solution-button").show();
			},200)

            return true;
        }
        return false;
    }

    AddChoiceHotelScript1(){

        //3邮件
        let newInfos=[
            {
                id:10001,name:"高朗",isread:false,subject:"市场上常见促销方法",date:"08:21 AM",desc:"上次会议之后，我把目前市场上常见的促销......",
                content:
                "上次会议之后，我把目前市场上常见的促销方法看了一下，主要有几种：<br/>" +
                "1.  价格冲击 – 通过调整价格来吸引更多客户选择入住。<br/>" +
                "2.  套餐活动 – 不仅提供酒店住房，还增加配套的活动，比如说三天养身排毒之旅，或养出玫瑰嫩肌等。<br/>" +
                "3.  特色营销 – 主打某一种主题或风格，比如说AA酒店，他们就增加了少数民族的风格配饰，针对用户喜好添加软装摆设。<br/>" +
                "4.  积分兑奖 – 在淡季时入住，客户可以得到更多的积分，一定的积分可以兑换不同的奖品。<br/>" +
                "我觉得我们酒店可以在2和4上面花点功夫，也想听听你的意见，期待回复。<br/>"
            },
            {
                id:10002,name:"高朗",isread:false,subject:"补充信息–建立战略关系",date:"08:38 AM",desc:"对了，还漏了一件事情和你说，我建议......",
                content:
                "对了，还漏了一件事情和你说，我建议我们可以和旅行社结成战略性伙伴关系。<br/>" +
                "比如说，旅行社在淡季为酒店带来多少客户，就能在旺季得到更多的配额。相信为了调剂需求，他们也会配合我们的促销手段。<br/>" +
                "其实我们还可以和周边的出租车或者网络打车平台合作，他们如果愿意帮忙宣传，我们在后面两个月转入淡季的时候，可能不会失去太多的客户来源。<br/>"
            },
            {
                id:10003,name:"王立娜",isread:false,subject:"网约房的紧急事件处理",date:"08:45 AM",desc:"领导，之前提到关于网约房的事情......",
                content:
                "目前网站供应商并没有给出明确答复，但他们同意下周和我们一起商讨具体的处理方案。您下周有空吗？我们可以与法务部一同出席该会议。<br/>" +
                "另外，这件事情也让我有了新的想法。目前在线销售商比较强势，大部分酒店都面临严苛的市场环境，我们可以考虑抱团取暖的方法。<br/>" +
                "比如说，A酒店联合了B、C、D三家酒店，目前形成了以它为首的四方联盟。E酒店收购了F和G两家酒店。这样，同类型酒店可以迅速扩<br/>" +
                "大经营规模、聚合会员、整合资源，酒店有更多的议价权，受到在线销售的影响也比较小。<br/>"
            }
        ];
        //this.unreadcount += 3;
        this.addNewEmail(newInfos);
        this.emailAnimations(this.getUnreadEmail());

    }

    AddChoiceHotelScript2(){

        //this.diglogueUnreadcount = 0;

        //Email +2, Message +1
        let newInfos=[
            {
                id:10004,name:"王立娜",isread:false,subject:"会务预定订单分析",date:"09:00 AM",desc:"领导，我把近两年来会务预定的订单做了分析......",
                content:
                "领导，我把近两年来会务预定的订单做了分析。<br/>\n" +
                "我发现我们会务的顾客群主要是政府机关和大企业等。虽然市场中有一些同类型酒店也以商务会议为主，但是我们酒店位于风景区，这是非常占优势的。<br/>\n" +
                "我想对于客户来说，一个既能度假旅游，又能举行会议的地方，才是理想之选。<br/>\n" +
                "另外，我也查看了会务的订单高峰期，通常是在年初或年底，年中的预定量并不多。所以，我建议这次的淡季是否能够主打会议营销？我觉得这可能会是增加营业额的重要手段。<br/>"
            },
            {
                id:10005,name:"秦飞",isread:false,subject:"促销活动的执行与沟通",date:" 09:12 AM",desc:"关于酒店淡季促销活动，你一定要关注活动的执行推进....",
                content:
                "关于酒店淡季促销活动，你一定要关注活动的执行推进，避免方案制定出来之后，因为客户的沟通不到位而造成损失。<br/>" +
                "从我的角度来看，你要第一时间和高朗合作，在官网和旅行社公布酒店促销信息，同时利用微博、微信等社交媒体进行传播，建立与客户之间的分享奖励机制，吸引传播。<br/>" +
                "另外，最好能派足够的人手，在酒店周边的社区、写字楼、商务中心等进行宣传。<br/>" +
                "还有千万不要忘记动员酒店的员工进行全员销售，但是呢，销售的奖励机制你要好好想想，毕竟现在总部希望我们能够考虑成本问题。<br/>"
            }
        ];
        //this.unreadcount += 3;
        this.addNewEmail(newInfos);

        this.emailAnimations(this.getUnreadEmail());

        let newMessages=[{
            id: 20001, profilePhoto: "gl-photo", name: "高朗", title: "积分兑奖", state: 0, List: [
                {t: 2, d:"上次我们开会时提到的“积分兑奖”，你有什么想法吗？"},
                {t: 1, d: "挺好啊！其实我一直觉得这招能够吸引不少客户，果然营销上还得靠你！"},
                {t: 2, d:"但是这个活动需要各部门的积极配合与支持，毕竟一旦推出这个活动，就要做出特色。"},
                {t: 1, d:"我同意。"},
                {t: 2, d:"我希望我们酒店能够做到客户一旦提出兑换，小宗奖品即时兑换，大宗奖品必须在3天内送至客户指定地点，你觉得能做到吗？"},
                {t: 1, d:"唔……这个听上去不错，但可行性上我还真得想想。"}
            ]
        }];

        this.addNewMessage(newMessages);

        this.messageAnimations(this.getUnreadMessage());
    }

    AddChoiceHotelDialogueScript(){

        if (this.diglogueList[0].List[0] == undefined || this.diglogueList[0].List[0].id != 30000) {
            //新对话
            this.diglogueList[0].unread = 1;
            //tempList = this.diglogueList[0].List;
            //this.moveToHistory(0);
            this.diglogueList[0].List.push(
                {
                    id:30000,title:"关于酒店淡季促销活动，需要关注以下几点…",state:0,data:[
                        "关于酒店淡季促销活动，要关注执行推进，尤其是沟通宣传方面，客户需要明确地知道我们酒店到底有哪些活动。",
                        "你要和小高一起合作，官网、微博、微信等平台要好好宣传，旅行社那边也要打点好，把我们的促销信息与客户分享，最好是能建立分享奖励机制，吸引客户自主传播。",
                        "另外，安排人在酒店周边的社区、写字楼、商务中心等进行宣传。还有，要动员酒店的员工进行全员销售，奖励机制也要跟上，不过由于成本原因，你要好好想想采用什么方式激励大家。"
                    ]
                });
        }

        if (this.diglogueList[1].List[0] == undefined || this.diglogueList[1].List[0].id != 30001) {
            this.moveToHistory(1);
            this.diglogueList[1].unread = 1;
            this.diglogueList[1].List.push(
                {
                    id:30001,title:"上次开会说到的积分兑奖，大家都很喜欢…",state:0,data:[
                        "上次开会时提到的积分兑奖形式，大家都很喜欢，我觉得既然要做，就要把这个活动做出特色来。",
                        "我的想法是，客户一旦提出兑换，小宗奖品即时兑换，大宗奖品必须在3天内送至客户指定地点。我知道这对我们来说有点难度，所以需要各部门的积极配合，你应该会帮忙吧？"
                    ]
                });
        }
        if (this.diglogueList[2].List[0] == undefined || this.diglogueList[2].List[0].id != 30002) {
            this.moveToHistory(2);
            this.diglogueList[2].unread = 1;
            this.diglogueList[2].List.push(
                {
                    id: 30002, title: "客户总不满意，我也不知道问题出在哪里，头疼…", state: 0, data: [
                        "我觉得我们做得挺好的，可客户总是不满意。是不是我们的服务人员都比较年轻的原因？比方说，我已经发现有些员工做起事来比较自我中心，或者粗心大意等等。",
                        "还有呀，领导，您之前提到关于酒店淡季促销的事情，我这次短途游的时候发现，外面同类型酒店房价要比我们这儿低上20%左右，您说要不要我们也降降价？"
                    ]
                });
        }
        if (this.diglogueList[3].List[0] == undefined || this.diglogueList[3].List[0].id != 30003) {
            this.moveToHistory(3);
            this.diglogueList[3].unread = 1;
            this.diglogueList[3].List.push(
                {
                    id: 30003, title: "领导，近两年来会务预定的订单分析发给您了，我觉得…", state: 0, data: [
                        "领导，我把近两年来会务预定的订单做了分析。我们会务的顾客群主要是政府机关和大企业等。",
                        "虽然有同类酒店，但我们的地理位置在风景区，是集旅游、休闲、度假和商务会议功能于一体的，所以比较占优势。",
                        "另外，往常我们会务在年初和年底会是订单高峰期，所以这次淡季我提议能否主推度假商务会议为卖点？"
                    ]
                });
        }
        if (this.diglogueList[4].List[0] == undefined || this.diglogueList[4].List[0].id != 30004) {
            this.moveToHistory(4);
            this.diglogueList[4].unread = 1;
            this.diglogueList[4].List.push(
                {
                    id:30004,title:"嘿，你来看看，我找到了一家不错的供应商，又便宜又好…",state:0,data:[
                        "你快来看看，我找到了一家供应商，他们的产品很不错，又便宜又好看，还非常时尚。我们酒店里的软装要不用这家的，怎么样？",
                        "预算这方面，我可以先出一版草案，到时候你帮着我一起去和总经理说说？"
                    ]
                });
        }

        this.dialogueStep = 1;
        this.dialogueAnimations(this.getDialogUnreadCount());
    }

    AddChoiceUpgradeScript1(){
        this.currentEmail = 0;
        //3邮件+1短信
        let newInfos=[
            {
                id:10011,name:"高朗",isread:false,subject:"用大数据打造人性化住宿服务",date:"07:31 AM",desc:"随着互联网的不断发展，未来大数据会成为趋势......",
                content:
                "随着互联网的不断发展，未来大数据会成为趋势，我们也需要利用大数据为我们服务。<br/>" +
                "我觉得我们需要致力于为入住的消费者提供时尚、贴心、健康、快乐、舒适的酒店住宿体验。<br/>" +
                "虽然我并不是项目的负责人，但从营销的角度上，我可以贡献一点想法。<br/>" +
                "1.  营销的本质是满足消费者的需求，而现在消费者的需求是为了满足心理、精神需求。<br/>" +
                "2.  在成熟市场上，顾客的消费习惯行为已由“目的消费”转为“手段消费”，因此只有做到风格化、个性化，才能获得顾客的心理认同。<br/>" +
                "3.  资料库的建立是非常有必要的。营销上是信息为王，服务上也应该这样做。拥有充足的顾客资料才能了解他们的需求，是提供个性化服务的基础。<br/>" +
                "我觉得如果要在酒店的服务上进行系统、全面的升级，并且要得到顾客的喜欢，首先要建立数据库，然后以老客户为基点，抓住老客户，营造好口碑，这样才有持续性进化的能力。<br/>"

            },
            {
                id:10012,name:"季宁",isread:false,subject:"提升酒店员工的个人形象和素质",date:"07:54 AM",desc:"领导，根据这段时间来客户的反馈和我自己的观察......",
                content:
                "&nbsp;&nbsp;领导，根据这段时间来客户的反馈和我自己的观察，我觉得提升团队服务人员的个人形象和素质是当务之急。<br/>" +
                "&nbsp;&nbsp;酒店的软件质量就是我们的服务水平，虽然我们的酒店开了10年，设备一直没有更新过，但若能提供良好的、令顾客满意的服务，可以在一定程度上弥补硬件方面的不足。<br/>" +
                "&nbsp;&nbsp;服务人员的个人形象和素质对顾客的情绪有直接的影响。我觉得我们需要尽快组织一系列培训，包括：仪容仪表、文明礼貌和服务态度，提升酒店的档次。<br/>"
            },
            {
                id:10013,name:"酒店行业协会",isread:false,subject:"加强酒店的安全管理",date:"08:45 AM",desc:"鉴于最近在本市发生多起酒店盗窃事件......",
                content:
                "鉴于最近在本市发生多起酒店盗窃事件，在此我们提醒行业同僚重视酒店内部安全管理问题。<br/>" +
                "1.  加强对员工的安全教育：<br/>" +
                "2.  狠抓内部安全管理<br/>" +
                "3.  配备安全防范设备设施。<br/>"+
                "4.  建立应急预案和管理规章制度。<br/>"
            }
        ];
        //this.unreadcount += 3;
        this.addNewEmail(newInfos);
        this.emailAnimations(this.getUnreadEmail());


        let newMessages=[{
            id: 20011, profilePhoto: "wln-photo", name: "王立娜", title: "现代年轻人的需求潮流", state: 0, List: [
                {t: 2, d:"领导，我昨天和几个朋友探讨了一下酒店服务的理念，他们给了一些想法，我觉得不错。"},
                {t: 1, d: "唔，不错，说来听听。"},
                {t: 2, d:"来我们酒店消费的人群越来越趋向年轻化，所以我觉得需要用心满足顾客的健身和社交需求。"},
                {t: 1, d:"这的确是现在年轻人比较喜欢的。"},
                {t: 2, d:"我想是不是能利用酒店的一些空间转角，设计一些交流区，或者是迷你健身区，让年轻的顾客可以随时锻炼，或能将简易的健身器材借回客房锻炼？"},
                {t: 1, d:"唔……这个想法听上去很有创意，而且对空间和成本的要求不高。"}
            ]
        }];
        this.addNewMessage(newMessages);
        this.messageAnimations(this.getUnreadMessage());
    }

    AddChoiceUpgradeScript2(){
        //this.diglogueUnreadcount=0;
        //1邮件+3短信
        this.currentEmail = 0;

        let newInfos=[
            {
                id:10021,name:"王立娜",isread:false,subject:"客户满意度持续下降",date:"08:58 AM",desc:"从客人在住宿后对酒店的反馈留言可以看出他们......",
                content:
                "从客人在住宿后对酒店的反馈留言可以看出他们的满意度并不高。<br/>" +
                "三个季度以来，好评率持续下滑，从原来90%，下滑至83%。这是个危险的信号，我们需要及时采取措施来阻止满意度的持续降低。<br/>" +
                "通过分析，住客对于我们的服务相应速度和质量都不太满意，我觉得可以从这两个方面入手。建议可以通过培训提升员工服务素养，并且加强正确服务理念的宣导：顾客是上帝，不论他们提出什么诉求，我们都应该设法满足。<br/>"
            }
        ];
        this.addNewEmail(newInfos);
        this.emailAnimations(this.getUnreadEmail());
        let newMessages=[{
            id: 20000, profilePhoto: "qf-photo", name: "秦飞", title: "对老客户更需要体现出个性化", state: 0, List: [
                {t: 2, d:"刚才我给你转了篇微博推送，里面的内容挺好的。"},
                {t: 1, d: "我看到了，这当中有个点很打动我，就是对老客户的保留措施。"},
                {t: 2, d:"没错，我也很喜欢这个观点。老客户的数据是我们酒店的财富，但这个财富之前一直没想好应该要怎么去发挥更大的作用。"},
                {t: 1, d:"对，看了这个推送，我觉得我们可以把老顾客的信息进行整理，包括姓名、住房偏好、饮食习惯，甚至是宗教信仰等等，这样等下次客人再次入住的时候，我们可以第一时间调用资料，提供让他们满意、贴心的服务。"},
                {t: 2, d:"是呀，你能这样想，我很欣慰。服务优化这块要多靠你来费心了。"},
                {t: 1, d:"没问题的，老板，您放心吧!"}
            ]
        }, {
            id: 20012, profilePhoto: "man-photo", name: "餐饮经理", title: "客户抱怨酒店餐厅的口味不好", state: 0, List: [
                {t: 1, d:"最近客户对酒店餐厅的评分有点低，这是怎么回事？"},
                {t: 2, d:"哦，关于这个，我问过几个关系不错的老客户，他们说不是餐厅的东西质量下降了，而是那么多年没变过口味，实在是有点吃腻了。"},
                {t: 1, d: "那你有什么应对措施吗？"},
                {t: 2, d:"引进新的大厨，搞创新菜色，加强餐厅服务水平，用这个方法来提升满意度。"},
                {t: 1, d:"嗯，能具体说说你的方案么？"},
                {t: 2, d:"现在有不少酒店推出自己的餐饮品牌，有顾客就是冲着酒店的餐厅去消费的。我们的食材并不差，如果菜色和口味上略作改变或许会起到意想不到的效果，也能打造新的品牌效应。"}
            ]
        },
            {
                id: 20013, profilePhoto: "man-photo", name: "朋友", title: "同类型酒店的服务体验分享", state: 0, List: [
                    {t: 1, d:"上个月出去旅游，感觉怎么样？体验好不好？"},
                    {t: 2, d:"真心不错！景色就不谈了，光说住的那家酒店就让我印象超级深刻！"},
                    {t: 1, d: "来来来，和我说说，到底哪里让你觉得好？"},
                    {t: 2, d:"酒店的服务非常贴心、到位。怎么说呢，我感觉就是服务的超满足性。它不仅能达到我的期待，甚至会超出期望值。"},
                    {t: 1, d:"能举个例子给我听听吗？"},
                    {t: 2, d:"比如说客房送餐服务吧，通常酒店的做法是餐具摆在餐盘上，但他们是把餐具放在一个草编的餐盒里，还装有两套适合饮用不同饮料的杯子，男女各一套。既卫生，又雅致！"}
                ]
            }
        ];
        this.addNewMessage(newMessages);
        this.messageAnimations(this.getUnreadMessage());
    }

    AddChoiceUpgradeDialogueScript(){

        //this.unreadcount = 0;
        //this.msgunreadcount = 0;
        this.currentEmail = 0;
        if (this.diglogueList[0].List[0] == undefined || this.diglogueList[0].List[0].id != 30010) {
            //新对话
            this.diglogueList[0].unread = 1;


            //tempList = this.diglogueList[0].List;
            this.moveToHistory(0);
            this.diglogueList[0].List=
                [{
                    id: 30010, title: "在数据为王的时代，对老客户更需要体现出…", state: 0, data: [
                        "刚才给你转了篇微博推送，建议抽空看一下，有些点说得很有道理，而且的确是能够给我们启发。",
                        "它有提到关于顾客信息的利用，数据时代就要用数据来说话，对于老客户我们要牢牢抓住，要提升服务的细致程度来让他们对我们满意。",
                        "入住过的顾客，再次入住时，他们的名字、喜好、饮食习惯都不再需要重复询问。这个理念与我们的价值观很相符。"
                    ]
                }];
        }
        if (this.diglogueList[1].List[0] == undefined || this.diglogueList[1].List[0].id != 30011) {
            this.moveToHistory(1);
            this.diglogueList[1].unread = 1;
            this.diglogueList[1].List =
                [{
                    id: 30011, title: "公众号上有篇酒店服务体验的内容很不错…", state: 0, data: [
                        "我在公众号上发了一篇关于酒店个性化服务的内容，分享给你看看。",
                        "我觉得传统的酒店力求提供100%的满意，但从现在的营销理论来看，即使客户达到完全满意后，出于猎奇的心理，他们还有很大可能转换别的酒店",
                        "为了使顾客成为某一品牌的忠实拥护者，就必须有100%+N%的满意度，N%就是意外的惊喜，超值的享受，让他们觉得你的服务超过了他们的期待。"
                    ]
                }];
        }
        if (this.diglogueList[2].List[0] == undefined || this.diglogueList[2].List[0].id != 30012) {
            this.moveToHistory(2);
            this.diglogueList[2].unread = 1;
            this.diglogueList[2].List =
                [{
                    id: 30012, title: "加速数字化和智能化，让消费者体验更好…", state: 0, data: [
                        "领导，现在我们的入住顾客中，年轻人比例越来越高，我觉得智能手机在酒店体验中的角色会越来越重要。",
                        "有调研显示，当酒店使用新科技时，66%的消费者会觉得体验更好，不论是订房、客房服务还是与服务人员的互动，年轻人会更习惯用APP或者各种社交媒体应用来完成。",
                        "我建议可以研发一款APP，包括手机门卡、智能预订、个性客房设定的功能等。"
                    ]
                }];
        }
        if (this.diglogueList[3].List[0] == undefined || this.diglogueList[3].List[0].id != 30013) {
            this.moveToHistory(3);
            this.diglogueList[3].unread = 1;
            this.diglogueList[3].List =
                [{
                    id: 30013, title: "我们应该设法满足宾客要求，不论何种诉求…", state: 0, data: [
                        "从客户意见簿中的留言不难看出，顾客对于我们的服务不论是响应速度还是质量都不太满意，我觉得可以从这两个方面入手。",
                        "建议可以通过培训提升员工服务素养，并且加强正确服务理念的宣导：顾客是上帝，不论他们提出什么诉求，我们都应该设法满足。"
                    ]
                }];
        }
        if (this.diglogueList[4].List[0] == undefined || this.diglogueList[4].List[0].id != 30014) {
            this.moveToHistory(4);
            this.diglogueList[4].unread = 1;
            this.diglogueList[4].List =
                [{
                    id: 30014, title: "建议机器人进入酒店业，用来提高人员效率…", state: 0, data: [
                        "你看，现在已经有很多五星级的高端酒店采用了智能机器人。",
                        "用智能机器人来提升服务体验流程和我们的服务速度，我个人觉得这个想法很有意思啦，毕竟有些重复性的工作，用人力来完成反而有可能会出错，但机器人只要设置好程序就会严格执行了，不知道你怎么看？"
                    ]
                }];
        }
        this.dialogueStep = 1;
        this.dialogueAnimations(this.getDialogUnreadCount());
    }

    AddChoiceEmployeeScript1(){
        //this.diglogueUnreadcount=0;
        //2邮件 1信息
        this.currentEmail = 0;
        let newInfos=[
            {
                id:10031,name:"魏丽",isread:false,subject:"预产期休假",date:"09:01 AM",desc:"各位亲爱的伙伴们，鉴于预产期临近，我将于......",
                content:
                "各位亲爱的伙伴们，鉴于预产期临近，我将于本周五开始正式休假。<br/>" +
                "工作交接列表请见附件，之后四个月的工作我已经交接给王立娜主管。不过如果大家有什么问题，也可以联系我。<br/>" +
                "伙伴们，九月初再见咯！<br/>"
            },
            {
                id:10032,name:"王立娜",isread:false,subject:"VVIP客户团接待事宜",date:"1:43 PM",desc:"领导，我想跟您确认下两周VVIP客户团的接待......",
                content:
                "领导，我想跟您确认下两周VVIP客户团的接待事宜。我知道酒店一直想拿下这个优质客户，所以，我也已经将接待细则做好了，希望这次能给客户留下好印象，未来能给酒店带来更多机会。<br/>" +
                "<br/>" +
                "这次接待活动时间紧、任务重，会务团队的人手肯定不够，我希望您能帮忙协调一下，从其他团队抽调4-5个人给我们。谢谢！<br/>"
            },
        ];
        //this.unreadcount += 2;
        this.addNewEmail(newInfos);
        this.emailAnimations(this.getUnreadEmail());
        let newMessages=[{
            id: 20031, profilePhoto: "man-photo", name: "黎启", title: "领导，不好意思，我今天在外面", state: 0, List: [
                {t: 1, d:"在吗？"},
                {t: 1, d:"来一下我的办公室。"},
                {t: 2, d:"额，领导，不好意思，我今天在外面......"},
                {t: 1, d:"今天收到你的邮件，说实话我非常惊讶。为什么突然想要离开呢？"},
                {t: 2, d:"可能是我的性格不太适合团队的节奏吧。我觉得这份工作压力挺大的，一有压力我就紧张，一紧张就容易犯错误......"}
            ]
        }];
        //this.msgunreadcount+=1;
        this.addNewMessage(newMessages);
        this.messageAnimations(this.getUnreadMessage());

    }

    AddChoiceEmployeeScript2(){
        //this.diglogueUnreadcount=0;
        this.currentEmail = 0;
        //2邮件 1信息
        let newInfos=[
            {
                id:10041,name:"高朗",isread:false,subject:"网约房合同",date:"2:12 PM",desc:"有件事我需要找你了解情况。我听说网约......",
                content:
                "有件事我需要找你了解情况。我听说网约房的合作伙伴不肯跟我们续约了，有这回事吗？<br/>"+
                "网约房是酒店的宣传重点之一，我们在印刷新的宣传手册时，就跟你们部门的黎启确认过续约是没问题的。现在宣传物料都到位了，我才知道合同还没签！<br/>"+
                "我现在需要一个明确的答案，让我们知道网约房到底能不能宣传。请你在这周五之前务必给我一个答复，谢谢。<br/>"
            },
            {
                id:10042,name:"秦飞",isread:false,subject:"黎启离职",date:"3:00 PM",desc:"员工的去留问题你自己看着办吧......",
                content:
                "员工的去留问题你自己看着办吧，不用问我，注意不要打乱部门的正常工作节奏。<br/>"+
                "另外，人员流动可能会影响到团队的士气，这点处理起来要当心。<br/>"
            },
        ];
        //this.unreadcount += 2;

        this.addNewEmail(newInfos);
        this.emailAnimations(this.getUnreadEmail());
        let newMessages=[{
            id: 20041, profilePhoto: "man-photo", name: "同事", title: "出主意，加工资", state: 0, List: [
                {t: 1, d:"听说你们黎启要离职？"},
                {t: 2, d:"……"},
                {t: 2, d:"什么八卦都逃不过你的耳朵！"},
                {t: 1, d:"那当然！"},
                {t: 1, d:"怎么回事？"},
                {t: 2, d:"小伙子觉得工作压力太大，撑不住……"},
                {t: 1, d:"啧啧啧，是嫌这里工资太低吧？黎启他们进来的时候工资都被压得死死的，后来也没涨过多少。和他同期进酒店的年轻人都已经走光了吧……"}
            ]
        }];
        //this.msgunreadcount += 1;
        this.addNewMessage(newMessages);
        this.messageAnimations(this.getUnreadMessage());

    }
    AddChoiceEmployeeDialogueScript(){
        //this.unreadcount = 0;
        //this.msgunreadcount = 0;

        //console.log(this.diglogueList[0].List[0]);
        if (this.diglogueList[0].List[0] == undefined || this.diglogueList[0].List[0].id != 30030) {
            //新对话
            this.diglogueList[0].unread = 1;


            //tempList = this.diglogueList[0].List;
            this.moveToHistory(0);
            this.diglogueList[0].List =
                [{
                    id: 30030, title: "你先找黎启问问情况…", state: 0, data: [
                        "你先找黎启问问情况，尽量快点解决。",
                        "记得啊，千万别拖延，不要影响团队其他人的情绪。"
                    ]
                }];
        }
        //console.log(this.diglogueList[1].List[0].id  + "  T:" + (this.diglogueList[1].List[0].id != 30031));
        if (this.diglogueList[1].List[0] == undefined || this.diglogueList[1].List[0].id != 30031) {
            this.moveToHistory(1);
            this.diglogueList[1].unread = 1;
            this.diglogueList[1].List =
                [{
                    id: 30031, title: "我们和黎启合作过几次，这个人的工作态度…", state: 0, data: [
                        "我们和黎启合作过几次，这个人的工作态度有点问题，从来不会主动去配合其他人的工作，每次都得靠别人催。",
                        "合同续约这么重要的事，他不去跟进，现在捅出天大的篓子！我建议你好好考察一下他的工作表现，如果总是这样，还不如让他走吧。"
                    ]
                }];
        }
        if (this.diglogueList[2].List[0]== undefined || this.diglogueList[0].List[0].id != 30032) {
            this.moveToHistory(2);
            this.diglogueList[2].unread = 1;
            this.diglogueList[2].List =
                [{
                    id: 30032, title: "黎启是不是最近发生什么事了？我印象中他…", state: 0, data: [
                        "黎启？我觉得他很好啊，挺开朗的一个人，也很有想法。比如他上次提出的那几个提升客户满意度的方案，效果都很不错。",
                        "我印象中他不是个粗枝大叶的人，怎么会犯这种错误？是不是最近发生什么事了？"
                    ]
                }];
        }
        if (this.diglogueList[3].List[0]== undefined || this.diglogueList[0].List[0].id != 30033) {
            this.moveToHistory(3);
            this.diglogueList[3].unread = 1;
            this.diglogueList[3].List =
                [{
                    id: 30033, title: "领导，我们所有人都忙得人仰马翻了。至于黎启平时的表现…", state: 0, data: [
                        "领导，我们所有人都忙得人仰马翻了。魏丽马上要去休产假，如果黎启离职，其他人的工作压力就太大了。",
                        "我观察过小黎他平时工作表现还是不错的。"
                    ]
                }];
        }
        if (this.diglogueList[4].List[0]== undefined ||this.diglogueList[0].List[0].id != 30034) {
            this.moveToHistory(4);
            this.diglogueList[4].unread = 1;
            this.diglogueList[4].List =
                [{
                    id: 30034, title: "压力大想辞职？一定是因为…", state: 0, data: [
                        "压力大想辞职？别是在外面找到新工作了吧。",
                        "能不能劝劝你的手下再待一段时间，这时候走人不厚道吧。"
                    ]
                }];
        }
        this.dialogueStep = 1;
        this.dialogueAnimations(this.getDialogUnreadCount());
    }
    onTabChanged(n){
        this.AddHotelSolutionDialogueHelp(n+1);
        this.selectedSolution = this.solutionList[n];
        if(this.selectedSolution.state == 0){
            this.selectedString = "选择方案";
        }else{
            this.selectedString = "取消方案";
        }
        this.diglogueUnreadcount = this.getDialogUnreadCount();
    }
    onSolutionClick($event){
        //防止出现阅读对话后选中的情况
        //if (this.currentIndex == 18)
        //    return;

        if (this.selectedSolution.state == 0){
            this.selectedSolution.state = 1;
            this.selectedString = "取消方案";
            if (!this.isNeedClick){
                this.isNeedClick = true;
            }
        }
        else{
            this.selectedSolution.state = 0;
            this.selectedString = "选择方案";
            this.isNeedClick  = !this.IsEmptySelected();
        }
    }

    IsEmptySelected(){
        let len = this.solutionList.length;
        let bl = true;
        for(var i = 0; i< len ;i++)
            if (this.solutionList[i].state == 1){
                bl = false;
                break;
            }

        return bl;
    }


    AddHotelSolution(){
        let question = this.solutionPart.GetSolutionList();
        this.currentQuestion = {
            id: question.id
        };
        this.solutionList = question.solutionList;
        this.onTabChanged(0);
    }

    AddHotelSolutionDialogueHelp(n){
        //this.moveToHistory(i);

        let dialogues = this.solutionPart.GetSolutionDialogueScript(n);
        //let unread = this.filterDialogueByHistory(dialogues);

        //this.unreadcount = 0;
        //this.msgunreadcount = 0;
        let val = 0;
        for(var i = 0 ; i< dialogues.length; i++ ){
            //if (dialogues[i].count>0){

            //console.log("["+i+"]="+this.diglogueList[i].unread);


            for(var j=0;j< this.diglogueList[i].List.length; j++ ){
                if (this.diglogueList[i].List[j].state == 0){
                    this.diglogueList[i].count--;
                    this.diglogueList[i].List.splice(j,1);
                    //console.log("j="+j);
                }
            }
            //this.moveToHistory(i);
            let bl = false;
            for(var j=0;j< dialogues[i].List.length; j++ ){
                for(var k=0;k< this.diglogueList[i].List.length; k++ ){
                    if  (dialogues[i].List[j].id == this.diglogueList[i].List[k].id){
                        bl = true;
                        dialogues[i].count--;
                        //console.log("dialogues[i].List[j].id="+dialogues[i].List[j].id);
                        break;
                    }
                }
                if (!bl)
                    this.diglogueList[i].List.push(dialogues[i].List[j]);
                bl = false;
            }
            this.diglogueList[i].List.reverse();
            this.diglogueList[i].unread = dialogues[i].count;
            val += dialogues[i].count;
            //}
        }
        this.dialogueStep = 1;
        if (val>0)
            this.dialogueAnimations(val);
    }

    Add_Step1_Help(){
        let dialogues = this.solutionPart.GetHelpStep1_DialogueScript();
        let val = 0;
        for(var i = 0 ; i< dialogues.length; i++ ){
            if (dialogues[i].count>0){
                val += dialogues[i].count;
                this.diglogueList[i].unread = dialogues[i].count;
                this.moveToHistory(i);
                this.diglogueList[i].List = dialogues[i].List;
            }
        }
        this.dialogueStep = 1;
        this.dialogueAnimations(val);

    }

    Add_Step2_Help(){
        let dialogues = this.solutionPart.GetHelpStep2_DialogueScript();
        let val = 0;
        for(var i = 0 ; i< dialogues.length; i++ ){
            if (dialogues[i].count>0){
                val += dialogues[i].count;
                this.diglogueList[i].unread = dialogues[i].count;

                for(var j=0;j< this.diglogueList[i].List.length; j++ ){
                    if (this.diglogueList[i].List[j].state == 0){
                        //this.diglogueList[i].count--;
                        this.diglogueList[i].List.splice(j,1);
                    }
                }
                for(var j=0;j< dialogues[i].List.length; j++ ){
                    this.diglogueList[i].List.push(dialogues[i].List[j]);
                }
                this.diglogueList[i].List.reverse();
                //this.diglogueList[i].List = dialogues[i].List;

            }
        }
        this.dialogueStep = 1;
        this.dialogueAnimations(val);

    }

    QuestionHotelSolutionTrueOrFalse(){
		this.optionSelectedIndex = -1;
        this.currentQuestion = this.solutionPart.QuestionHotelSolutionTrueOrFalse();
        this.selectedMutliChoice = {};
        $(".choice-title").html(this.currentQuestion.title);
        this.Add_Step1_Help();
    }

    QuestionHotelSolutionSingleChoice(){
        //this.
        this.currentQuestion = this.solutionPart.QuestionHotelSolutionSingleChoice();
        this.optionSelectedIndex = -1;
        $(".choice-title").html(this.currentQuestion.title);
        this.Add_Step2_Help();
    }
    GetHotelSolutionTip(){
        return this.solutionPart.GetHotelSolutionTip(this.optionSelectedIndex);
    }

    GotoLastQuestion(){
        console.log("go in 36");
        //this.hidefakeIcon();
        //酒店
        this.optionSelectedIndex = -1;
        this.currentQuestion = this.solutionPart.GotoLastQuestion();


        for(var i=0;i<5;i++){
            this.moveToHistory(i);
            this.diglogueList[i].List =[];
            this.diglogueList[i].unread = 0;
        }

        this.diglogueUnreadcount = 0;

        //type = 1;
        $("#mindyicon").show();
        $("#tipText").html(this.currentQuestion.title);
        $("#choiceTip").show();
        $(".choice-title").html("");
        $("#single-choice").addClass("single-choice-small").show();

    }


    gotoExceptChoice(qid){

        $("#single-choice").hide();
        $("#single-choice").removeClass("single-choice-small");

        this.selectedMutliChoice ={};

        let question = this.solutionPart.GetExtraQuestion(qid);

        let type = question.id== 75? 1 : 5;
        //83题为多选特殊处理
        let typeString = "单选题";
        this.optionSelectedIndex = -1;
        if(question.id== 83){
            typeString = "多选题";
            type = 2;
            //this.optionSelectedIndex = 0;
        }
        this.currentQuestion = {
            id:question.id,
            title:question.title,
            type:typeString,
            sub:type,
            options:[
                "酒店总经理",
                "人力资源部",
                "工程部",
                "会务部",
                "前厅部",
                "市场推广部"
            ]
        };
        if (question.id== 75){
            this.currentQuestion.options.push("销售部");
        }

        this.selectedMutliChoice = {};
        $(".choice-title").html(this.currentQuestion.title);
        //this.showQuestionDialogue(1);
        let That = this;
        var interval = setInterval(function () {
            That.showQuestionDialogue(1);
            clearInterval(interval);//停止
        }, 200);
    }


    gotoCreateReport(){
        this.isFinish = true;
        console.log("OK!");
        this.optionSelectedIndex = 0;
        $("#step6-solution-button").hide();
        $("#mindyReportHead").fadeIn(500);
        $("#mindyReportTip").show();
        $("#mindyReportTip").css("transform", "scale(0.3)");
        $("#mindyReportTip").css("opacity","0.1");
        var interval = setInterval(function () {
            $("#mindyReportTip").css("transform", "scale(1)").animate({"opacity":"1"},function () {
                $("#step7-solution-button").html("生成报告");
                $("#step7-solution-button").fadeIn(500);
            });
            clearInterval(interval);//停止
        }, this.delayTime);


    }

    closeShade(){
        this.hidefakeIcon();
        $("#step93-shade").hide();
    }

    dialogueAnimations(val){
        let that = this;
        let tmp_count = val;
        //动画时数字不清0
        //this.diglogueUnreadcount = 0;
      $("#dialogueicon").removeClass("shake");
      setTimeout(function () {
        $("#dialogueicon").addClass("shake");
      },100)
        this.diglogueUnreadcount = this.getDialogUnreadCount();
        //console.log("动画："+this.diglogueUnreadcount);

        if (this.diglogueUnreadcount == 0)
            return;
        // var interval = setInterval(function () {
        //     $("#dialogueicon").removeClass("shake");
        //
        //     clearInterval(interval);//停止
        // }, 7000);
    }

    emailAnimations(val){
        let that = this;
        let tmp_count = val;
        //动画时数字不清0
        this.unreadcount = val;
      $("#emailicon").removeClass("shake");
      setTimeout(function () {
        $("#emailicon").addClass("shake");
      },100)

        // var interval = setInterval(function () {
        //     $("#emailicon").removeClass("shake");
        //     //that.unreadcount = tmp_count;
        //     clearInterval(interval);//停止
        // }, 7000);
    }

    messageAnimations(val){
        let that = this;
        let tmp_count = val;
        this.msgunreadcount= val;
        //动画时数字不清0
      $("#messageicon").removeClass("shake");
      setTimeout(function () {
        $("#messageicon").addClass("shake");
      },100)

        // var interval = setInterval(function () {
        //     $("#messageicon").removeClass("shake");
        //     //that.msgunreadcount = tmp_count;
        //     clearInterval(interval);//停止
        // }, 7000);
    }

    //使用场景1。 对话场景   2。导师头像
    showfakeIcon(){
        $("#fake_emailicon").show();
        $("#fake_messageicon").show();
        $("#fake_dialogueicon").show();
        $("#emailicon").hide();
        $("#messageicon").hide();
        $("#dialogueicon").hide();

        if(this.currentIndex == 13){
        	$("#fake_messageicon").hide();
        	$("#fake_dialogueicon").hide();

        }else if(this.currentIndex == 15){
        	$("#fake_dialogueicon").hide();
        }
    }

    hidefakeIcon(){
        $("#fake_emailicon").hide();
        $("#fake_messageicon").hide();
        $("#fake_dialogueicon").hide();
        $("#emailicon").show();
        $("#messageicon").show();
        $("#dialogueicon").show();

        if(this.currentIndex == 14){
        	$("#messageicon").hide();
        	$("#dialogueicon").hide();

        }else if(this.currentIndex == 15){
        	$("#dialogueicon").hide();
        }

    }

    linkToReport(){
        const exerciseMetaId=$('#exerciseMetaId').val()
        this.apiService.learingTime({learningPathMetaId:localStorage.getItem('learningPathMetaId'),module:'情景模拟',courseUnit:'',type:2,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
            console.log(result)
          })
          console.log(exerciseMetaId)
          this.commonService.sendPostMessage(2,'isPractice' +'Complete')
      // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':localStorage.getItem('learningPathMetaId'),'module':'退出情景模拟1'}).then();
        let link=['case-practice-report-new-2',this.service.userId, this.exerciseId ,this.learningPathId];
        let type = null
        this.route.queryParams.subscribe(queryParams=>{
            type=queryParams['type']
        })
        if(type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
        }else{
            this.router.navigate(link);
        }

    }

    filterDialogueByHistory(dialogues){

        let len = dialogues.length;
        let ar = [];
        let bl = false;
        let unread = 0;
        for (var j =0; j< 5 ;j++){
            var count = this.diglogueList[j].List.length;
            for(var k = 0;k< count;k++){
                if (this.diglogueList[j].List[k].state == 0){
                    dialogues[j].count--;
                    dialogues[j].List.splice(k,1);
                }
            }
            if (dialogues[j].List!=null && dialogues[j].List.length > 0)
                unread+=1;

        }
        return unread;
    }

    InitMockData(){

        this.lock = true;
        this.solutionPart.episode = 2;

        this.AddHotelSolution();
        this.selectedSolution = this.solutionList[0];

        $("#step6-solution-tab").show();
        $("#step6-solution-content").show();
        $("#step6-solution-button").show();

    }

    //记录点
    loadRecord(data){
    	var _this = this;
		let qstObj  = new questionConfig();
		let qstId = 0;
		let answerString = "0";
		if(data.userBehavior && data.userBehavior.behaviorid){
			qstId = data.userBehavior.behaviorid;
			answerString = data.userBehavior.behaviorcontent;
		}
		//确定选择哪条支线
		_this.solutionPart.episode = 0;
		// 资源信息加载
		let eConfig = new emailConfig();
		let emConfig = eConfig.getEmailList(data.emails,qstId,answerString);
		this.emails = emConfig.mailList;
		this.emaihistlst = emConfig.mailListHistory;

		let messageConfig = eConfig.getMessageList(data.messages,qstId,answerString);
		this.messagebox.List = messageConfig.messageList
		this.messagebox.History = messageConfig.messageListHistory

		let dialogConfig = eConfig.getDiaglogueList(this.diglogueList, data.diaglogues,qstId,answerString);

		this.energyVal =  70 + emConfig.removeValue + messageConfig.removeValue + dialogConfig.removeValue;
		$("#emgnumber").html(this.energyVal + "/70");
		$("#emgvalue").css("width",parseInt(160 / 70 * this.energyVal+ "") +"px");

		//答题后提示不同显示
		if(data.userBehavior && data.userBehavior.behaviortype == 4){
			this.solutionPart.episode = data.userBehavior.stage;
			this.showTopTools();
			this.IsEnterEmail = true;
			this.IsEnterMessage = true;
			this.unreadcount = emConfig.unReadCount;
	        this.msgunreadcount = messageConfig.unReadCount;
			this.diglogueUnreadcount = dialogConfig.unReadCount;
			qstObj.recoverState(_this,data.userBehavior.behaviorid,data.userBehavior.behaviorcontent)
		}else{
			//答题前
			if(messageConfig.unReadCount != 2){
				//非第一次进入,去除首屏提示
				$("#shade").hide();
				this.showTopTools();
	            $("#emgvalue").css("position","absolute").css("z-index","0");
	            $("#emgmaxvalue").css("position","absolute").css("z-index","-1");
	            $("#emgtitle").css("position","absolute").css("z-index","0");
	            $("#emgnumber").css("position","absolute").css("z-index","0");
	            $("#emailicon").css("position","absolute").css("z-index","0");

	            $("#know").hide();
	            $("#emghelparrow").hide();
	            $("#nin").hide();
	            $("#dialogueicon").hide();
	            $("#dialogueunreader").hide();
	            this.currentIndex = 16;
	            this.onUnlock();
	            this.unreadcount = emConfig.unReadCount;
	            this.IsEnterEmail = true;
				this.IsEnterMessage = true;
				this.msgunreadcount = messageConfig.unReadCount;
				this.diglogueUnreadcount = dialogConfig.unReadCount;
                setTimeout(function(){
                    $("#messageunreader").css("position","absolute").css("z-index","0");
                    $("#emailunreader").css("position","absolute").css("z-index","0");
                },50);


			}else if(emConfig.unReadCount != 2){
				//非第一次进入,去除首屏提示
				$("#shade").hide();
				this.showTopTools();
	            $("#emgvalue").css("position","absolute").css("z-index","0");
	            $("#emgmaxvalue").css("position","absolute").css("z-index","-1");
	            $("#emgtitle").css("position","absolute").css("z-index","0");
	            $("#emgnumber").css("position","absolute").css("z-index","0");
	            $("#know").hide();
	            $("#emghelparrow").hide();
	            $("#nin").hide();
	            $("#dialogueicon").hide();
	            $("#dialogueunreader").hide();
	            this.currentIndex = 14;
	            this.onUnlock();
	            this.unreadcount = emConfig.unReadCount;
	            this.IsEnterEmail = true;
				//this.msgunreadcount = messageConfig.unReadCount;
				//this.diglogueUnreadcount = dialogConfig.unReadCount;
                setTimeout(function(){
                    $("#emailunreader").css("position","absolute").css("z-index","0");
                },50);
			}else{
				//所有加载完成才可以点击页面
				//this.lock = false;
			}
		}

    }
	//单独恢复动画
	loadRecordDialogs(callback){
		var _this = this;
        var interval = setInterval(function () {
            if (_this.isLoaded){

                $.ajax({
                    url: _this.baseURL + "/api/recovery/"+_this.service.userId,
                    type: "get",
                    dataType:'json',
                    success:function(result){
                        //console.log(data);
                        let qstObj  = new questionConfig();
                        //资源信息加载
                        let eConfig = new emailConfig();
                        if(result.userBehavior && result.userBehavior.behaviortype == 4){
                            let dialogConfig = eConfig.getDiaglogueList(
                                _this.diglogueList,
                                result.diaglogues,
                                result.userBehavior.behaviorid,
                                result.userBehavior.behaviorcontent);
                            _this.diglogueUnreadcount = dialogConfig.unReadCount;
                        }
                        let emConfig = eConfig.getEmailList(result.emails,result.userBehavior.behaviorid,result.userBehavior.behaviorcontent);
						_this.emails = emConfig.mailList;
						_this.emaihistlst = emConfig.mailListHistory;

						let messageConfig = eConfig.getMessageList(result.messages,result.userBehavior.behaviorid,result.userBehavior.behaviorcontent);
						_this.messagebox.List = messageConfig.messageList
						_this.messagebox.History = messageConfig.messageListHistory

						_this.unreadcount = emConfig.unReadCount;
	        			_this.msgunreadcount = messageConfig.unReadCount;

                        //数据回调
                        callback();
                    },
                    error:function(er){
                        _this.LogErrorInfo(er);
                    }
                });
                clearInterval(interval);//停止
            }

        }, 200);

	}

	CloseTipMessage(){
		$("#tipMessage").hide();
	}

    getMutlTypeValue(id){
        let ar;
        let result = "";
        if(id == 8 )
        {
            ar = [
                "客户满意度下滑，比上个月又低了5%",
                "同类型的酒店房价比我们低，可降低房价进行促销",
                "注重促销活动的沟通方案，信息传递要及时",
                "可与旅行社和用车平台结成战略性伙伴关系",
                "套餐活动和积分兑奖可能是这次促销上的重点推荐",
                "会务营销或成为这次淡季里的卖点之一",
                "调动酒店的成员参与促销，激励措施要合理"
            ];

        }
        else if (id == 18 ){

        }
        else if (id == 28){

        }

        return null;
    }

    IsShowHelperICon(){
    	return ['2630','2632','2692','2693','2695','2697'].indexOf(this.service.userId + '' ) >-1;
    }

    //防止重复排序
	questionOptionSortEnable:any = {};

    SortQuestionOption(){
    	let qstId = this.currentQuestion.id;
    	//解决方案不重新排序
    	if([36,37,38].indexOf(qstId) > -1){
    		return this.currentQuestion.options;
    	}
		if(this.questionOptionSortEnable[qstId] && this.questionOptionSortEnable[qstId] == 1){
			return this.currentQuestion.options;
		}else{
			this.questionOptionSortEnable[qstId] = 1;
			let josnStr = JSON.stringify(this.currentQuestion.options);
			this.originOption = JSON.parse(josnStr);
			this.currentQuestion.options.sort(function(){
	            return 0.5 - Math.random();
	        });
			return this.currentQuestion.options;
		}
    }

    GetSingleTureAnswer(){
		if(!this.currentQuestion.options){
			this.trueSelectedIndex = this.optionSelectedIndex;
			return this.trueSelectedIndex;
		}
    	let qstId = this.currentQuestion.id;
    	//解决方案不重新排序
    	if([36,37,38].indexOf(qstId) > -1){
    		this.trueSelectedIndex = this.optionSelectedIndex;
    		return this.trueSelectedIndex;
    	}
    	let chkAnswer = this.currentQuestion.options[this.optionSelectedIndex];
    	this.trueSelectedIndex = this.originOption.indexOf(chkAnswer);
    	return this.trueSelectedIndex;
    	//防止题目显示错位
//  	if(qstId == 1){
//	    	let singleChoice = $("#single-choice");
//	    	singleChoice.css("opacity","0");
//  	}
//  	return this.optionSelectedIndex;
    }

   	GetMutliTureAnswer(){
   		let qstId = this.currentQuestion.id;
    	//解决方案不重新排序
    	if([36,37,38].indexOf(qstId) > -1){
    		return this.selectedMutliChoice;
    	}
   		let selectedNewMutliChoice = {};
   		for(var key in this.selectedMutliChoice) {
            if (this.selectedMutliChoice[key]) {
                let chkAnswer = this.currentQuestion.options[key];
    			let newKey = this.originOption.indexOf(chkAnswer);
    			selectedNewMutliChoice[newKey] = true;
            }
        }
   		return selectedNewMutliChoice;
   	}
}



// WEBPACK FOOTER //
// ./src/app/case-practice-hotel/case-practice-hotel.component.ts